// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   COURSE PAYMENT ANALYTICS
   ============================================================ */

.cpa-app {
  --cpa-bg: #f5f8fb;
  --cpa-surface: #ffffff;
  --cpa-border: #d7d7d7;
  --cpa-border-dark: #c8d0d8;
  --cpa-text: #17202a;
  --cpa-muted: #5f6b76;
  --cpa-soft: #edf6fc;
  --cpa-primary: #347cb5;
  --cpa-primary-dark: #173f63;
  --cpa-primary-soft: #dcecf8;
  --cpa-paid: #347cb5;
  --cpa-pending: #6ead4f;
  --cpa-pending-soft: #e8f3d8;
  --cpa-shadow: 0 8px 30px rgba(23, 33, 43, 0.06);

  width: 100%;
  min-height: 100%;
  padding: 28px;
  background: var(--cpa-bg);
  color: var(--cpa-text);
  font-family:
    Inter,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
}

/* ============================================================
   HEADER
   ============================================================ */

.cpa-masthead {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 22px;
}

.cpa-brand-block {
  min-width: 0;
}

.cpa-eyebrow {
  margin-bottom: 7px;
  color: var(--cpa-primary);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.cpa-masthead h1 {
  margin: 0;
  color: var(--cpa-text);
  font-size: clamp(25px, 3vw, 34px);
  font-weight: 750;
  letter-spacing: -0.035em;
  line-height: 1.1;
}

.cpa-sub {
  margin: 8px 0 0;
  color: var(--cpa-muted);
  font-size: 14px;
  line-height: 1.5;
}

.cpa-course-context {
  min-width: 260px;
  max-width: 390px;
  padding: 16px 18px;
  border: 1px solid var(--cpa-border);
  border-radius: 12px;
  background: var(--cpa-surface);
  box-shadow: 0 4px 18px rgba(23, 33, 43, 0.04);
}

.cpa-context-label {
  margin-bottom: 5px;
  color: var(--cpa-muted);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.cpa-cname {
  overflow: hidden;
  color: var(--cpa-text);
  font-size: 15px;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpa-cmeta {
  margin-top: 5px;
  color: var(--cpa-primary);
  font-size: 12px;
  font-weight: 650;
}

.cpa-cid {
  margin-top: 7px;
  overflow: hidden;
  color: #9aa2aa;
  font-family:
    "SFMono-Regular",
    Consolas,
    monospace;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ============================================================
   CONTROL PANEL
   ============================================================ */

.cpa-panel {
  position: relative;
  margin-bottom: 18px;
  padding: 20px;
  border: 1px solid var(--cpa-border);
  border-radius: 14px;
  background: var(--cpa-surface);
  box-shadow: var(--cpa-shadow);
}

.cpa-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 17px;
}

.cpa-panel-title {
  color: var(--cpa-text);
  font-size: 14px;
  font-weight: 750;
}

.cpa-panel-subtitle {
  margin-top: 3px;
  color: var(--cpa-muted);
  font-size: 12px;
}

.cpa-selection-count {
  flex-shrink: 0;
  padding: 6px 10px;
  border: 1px solid #cce7e3;
  border-radius: 7px;
  background: var(--cpa-primary-soft);
  color: var(--cpa-primary-dark);
  font-size: 11px;
  font-weight: 700;
}

.cpa-panel-grid {
  display: grid;
  grid-template-columns:
    minmax(240px, 1.15fr)
    minmax(240px, 1.15fr)
    auto;
  align-items: end;
  gap: 14px;
}

.cpa-field {
  min-width: 0;
}

.cpa-field label {
  display: block;
  margin-bottom: 7px;
  color: #3d4852;
  font-size: 12px;
  font-weight: 700;
}

.cpa-control {
  width: 100%;
  min-height: 44px;
  padding: 0 38px 0 13px;
  border: 1px solid var(--cpa-border-dark);
  border-radius: 9px;
  outline: none;
  background: #fff;
  color: var(--cpa-text);
  font-size: 13px;
  font-weight: 550;
  cursor: pointer;
  transition:
    border-color 0.16s ease,
    box-shadow 0.16s ease;
}

.cpa-control:focus {
  border-color: var(--cpa-primary);
  box-shadow: 0 0 0 3px rgba(8, 127, 115, 0.1);
}

.cpa-control:disabled {
  background: #f1f3f5;
  color: #9aa2aa;
  cursor: not-allowed;
}

.cpa-field-hint {
  margin-top: 6px;
  color: var(--cpa-muted);
  font-size: 10px;
}

/* ============================================================
   TERM SELECT
   ============================================================ */

.cpa-term-select {
  position: relative;
  width: 100%;
}

.cpa-term-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 44px;
  padding: 0 13px;
  border: 1px solid var(--cpa-border-dark);
  border-radius: 9px;
  outline: none;
  background: #fff;
  color: var(--cpa-text);
  font-size: 13px;
  font-weight: 550;
  text-align: left;
  cursor: pointer;
  transition:
    border-color 0.16s ease,
    box-shadow 0.16s ease;
}

.cpa-term-trigger:hover:not(:disabled) {
  border-color: #aeb8c1;
}

.cpa-term-trigger:focus {
  border-color: var(--cpa-primary);
  box-shadow: 0 0 0 3px rgba(8, 127, 115, 0.1);
}

.cpa-term-trigger:disabled {
  background: #f1f3f5;
  color: #9aa2aa;
  cursor: not-allowed;
}

.cpa-term-trigger-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpa-chev {
  flex-shrink: 0;
  margin-left: 10px;
  color: #7e8993;
  font-size: 15px;
}

.cpa-term-dropdown {
  position: absolute;
  z-index: 100;
  top: calc(100% + 7px);
  left: 0;
  width: 100%;
  min-width: 245px;
  overflow: hidden;
  border: 1px solid var(--cpa-border);
  border-radius: 11px;
  background: #fff;
  box-shadow:
    0 16px 42px rgba(23, 33, 43, 0.14),
    0 3px 10px rgba(23, 33, 43, 0.06);
}

.cpa-term-dropdown-actions {
  display: flex;
  justify-content: space-between;
  padding: 9px 11px;
  border-bottom: 1px solid var(--cpa-border);
  background: #fafbfc;
}

.cpa-term-dropdown-actions button {
  padding: 4px 6px;
  border: 0;
  background: transparent;
  color: var(--cpa-primary);
  font-size: 11px;
  font-weight: 750;
  cursor: pointer;
}

.cpa-term-dropdown-actions button:disabled {
  color: #adb4bb;
  cursor: not-allowed;
}

.cpa-term-options {
  max-height: 230px;
  overflow-y: auto;
  padding: 5px;
}

.cpa-term-option {
  display: flex;
  align-items: center;
  gap: 9px;
  min-height: 37px;
  padding: 0 8px;
  border-radius: 7px;
  color: #35414c;
  font-size: 12px;
  cursor: pointer;
}

.cpa-term-option:hover {
  background: #f4f7f7;
}

.cpa-term-option input {
  width: 15px;
  height: 15px;
  margin: 0;
  accent-color: var(--cpa-primary);
}

.cpa-term-empty {
  padding: 18px 10px;
  color: var(--cpa-muted);
  font-size: 11px;
  text-align: center;
}

.cpa-term-dropdown-footer {
  padding: 8px 11px;
  border-top: 1px solid var(--cpa-border);
  color: var(--cpa-muted);
  font-size: 10px;
  font-weight: 600;
}

/* ============================================================
   ACTIONS
   ============================================================ */

.cpa-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cpa-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 42px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease,
    background 0.15s ease,
    border-color 0.15s ease;
}

.cpa-btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.cpa-btn:disabled {
  opacity: 0.48;
  cursor: not-allowed;
  transform: none;
}

.cpa-btn-primary {
  border: 1px solid var(--cpa-primary);
  background: var(--cpa-primary);
  color: #fff;
  box-shadow: 0 4px 12px rgba(8, 127, 115, 0.17);
}

.cpa-btn-primary:hover:not(:disabled) {
  background: var(--cpa-primary-dark);
}

.cpa-btn-secondary {
  border: 1px solid var(--cpa-border-dark);
  background: #fff;
  color: #35414c;
}

.cpa-btn-secondary:hover:not(:disabled) {
  border-color: #b4bec6;
  background: #f9fafb;
}

.cpa-btn-ghost {
  border: 1px solid #cce2df;
  background: var(--cpa-primary-soft);
  color: var(--cpa-primary-dark);
}

.cpa-btn-ghost:hover:not(:disabled) {
  background: #def0ed;
}

.cpa-refresh-icon {
  font-size: 17px;
  line-height: 1;
}

.cpa-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: cpa-spin 0.7s linear infinite;
}

@keyframes cpa-spin {
  to {
    transform: rotate(360deg);
  }
}

/* ============================================================
   VALIDATION / ERROR
   ============================================================ */

.cpa-validation-msg,
.cpa-banner {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-top: 13px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 550;
}

.cpa-validation-msg {
  border: 1px solid #f0d9ad;
  background: #fff8ec;
  color: #80500d;
}

.cpa-banner {
  margin-bottom: 18px;
}

.cpa-banner-error {
  border: 1px solid #f0caca;
  background: #fff5f5;
  color: #963838;
}

.cpa-banner-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  border-radius: 50%;
  background: currentColor;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
}

/* ============================================================
   DASHBOARD CONTEXT
   ============================================================ */

.cpa-dashboard-context {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 16px;
}

.cpa-dashboard-course {
  color: var(--cpa-text);
  font-size: 19px;
  font-weight: 760;
  letter-spacing: -0.02em;
}

.cpa-dashboard-term-line {
  margin-top: 4px;
  color: var(--cpa-muted);
  font-size: 11px;
}

.cpa-dashboard-term-line span {
  margin-left: 4px;
  color: var(--cpa-primary);
  font-weight: 700;
}

.cpa-dashboard-meta {
  color: #8a949d;
  font-size: 10px;
  text-align: right;
}

/* ============================================================
   SUMMARY CARDS
   ============================================================ */

.cpa-summary-cards {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 13px;
  margin-bottom: 14px;
}

.cpa-summary-card {
  display: flex;
  gap: 13px;
  min-height: 132px;
  padding: 17px;
  border: 1px solid var(--cpa-border);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 18px rgba(23, 33, 43, 0.045);
}

.cpa-summary-card.cpa-primary-metric {
  border-color: #c7e4df;
  box-shadow:
    0 5px 20px rgba(8, 127, 115, 0.09);
}

.cpa-sc-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  border-radius: 9px;
  font-size: 11px;
  font-weight: 850;
}

.cpa-icon-neutral {
  background: #eef1f3;
  color: #5e6972;
}

.cpa-icon-paid {
  background: var(--cpa-primary-soft);
  color: var(--cpa-primary);
  font-size: 17px;
}

.cpa-icon-pending {
  background: var(--cpa-pending-soft);
  color: var(--cpa-pending);
  font-size: 17px;
}

.cpa-icon-pct {
  background: #eef1f3;
  color: #46535e;
  font-size: 14px;
}

.cpa-sc-content {
  min-width: 0;
}

.cpa-sc-label {
  color: #56616b;
  font-size: 11px;
  font-weight: 750;
}

.cpa-sc-value {
  margin-top: 7px;
  color: var(--cpa-text);
  font-size: 25px;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1;
}

.cpa-paid .cpa-sc-value {
  color: var(--cpa-primary-dark);
}

.cpa-pending .cpa-sc-value {
  color: #9a5b10;
}

.cpa-sc-desc {
  margin-top: 8px;
  color: #8a949d;
  font-size: 10px;
  line-height: 1.4;
}

/* ============================================================
   PROGRESS
   ============================================================ */

.cpa-progress-card {
  margin-bottom: 21px;
  padding: 20px;
  border: 1px solid var(--cpa-border);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 18px rgba(23, 33, 43, 0.04);
}

.cpa-progress-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.cpa-section-kicker {
  margin-bottom: 3px;
  color: var(--cpa-primary);
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.cpa-pc-title {
  color: var(--cpa-text);
  font-size: 15px;
  font-weight: 760;
}

.cpa-pc-pct {
  color: var(--cpa-primary-dark);
  font-size: 22px;
  font-weight: 800;
}

.cpa-pc-stat {
  margin-top: 12px;
  color: #59656f;
  font-size: 12px;
}

.cpa-progress-track {
  width: 100%;
  height: 9px;
  margin-top: 14px;
  overflow: hidden;
  border-radius: 99px;
  background: #e9eeef;
}

.cpa-progress-fill {
  height: 100%;
  border-radius: inherit;
  background: var(--cpa-primary);
  transition: width 0.5s ease;
}

.cpa-progress-note {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-top: 11px;
  color: #7b858e;
  font-size: 10px;
  line-height: 1.45;
}

.cpa-info-dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  border: 1px solid #c8d1d7;
  border-radius: 50%;
  color: #7d8891;
  font-size: 9px;
  font-weight: 800;
}

/* ============================================================
   SECTIONS
   ============================================================ */

.cpa-section {
  margin-bottom: 21px;
}

.cpa-section-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 11px;
}

.cpa-section-title {
  color: var(--cpa-text);
  font-size: 15px;
  font-weight: 760;
  letter-spacing: -0.01em;
}

.cpa-tag {
  display: inline-flex;
  align-items: center;
  padding: 5px 8px;
  border-radius: 6px;
  font-size: 9px;
  font-weight: 700;
}

.cpa-tag-muted {
  background: #edf1f3;
  color: #68737d;
}

/* ============================================================
   TERM CARDS
   ============================================================ */

.cpa-term-cards {
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(210px, 1fr)
  );
  gap: 11px;
}

.cpa-term-card {
  padding: 14px;
  border: 1px solid var(--cpa-border);
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 3px 14px rgba(23, 33, 43, 0.035);
}

.cpa-tc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #edf0f2;
}

.cpa-tc-name {
  color: var(--cpa-text);
  font-size: 12px;
  font-weight: 800;
}

.cpa-tc-percent {
  color: var(--cpa-primary);
  font-size: 12px;
  font-weight: 800;
}

.cpa-tc-main {
  display: flex;
  align-items: center;
  gap: 17px;
  padding: 13px 0 10px;
}

.cpa-tc-stat {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.cpa-tc-stat-label {
  color: #8a949d;
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
}

.cpa-tc-stat strong {
  font-size: 18px;
  font-weight: 800;
}

.cpa-tc-paid {
  color: var(--cpa-primary-dark);
}

.cpa-tc-pending {
  color: #9a5b10;
}

.cpa-tc-divider {
  width: 1px;
  height: 30px;
  background: #e7eaec;
}

.cpa-tc-progress-track {
  height: 5px;
  overflow: hidden;
  border-radius: 99px;
  background: #edf0f1;
}

.cpa-tc-progress-fill {
  height: 100%;
  border-radius: inherit;
  background: var(--cpa-primary);
}

.cpa-term-cards-empty {
  padding: 18px;
  border: 1px dashed var(--cpa-border-dark);
  border-radius: 9px;
  color: var(--cpa-muted);
  font-size: 11px;
  text-align: center;
}

/* ============================================================
   TABLE CARD
   ============================================================ */

.cpa-table-card {
  overflow: hidden;
  margin-bottom: 17px;
  border: 1px solid var(--cpa-border);
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 4px 18px rgba(23, 33, 43, 0.04);
}

.cpa-table-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  padding: 17px 18px;
  border-bottom: 1px solid var(--cpa-border);
}

.cpa-table-caption {
  color: #8a949d;
  font-size: 10px;
  font-weight: 600;
}

/* ============================================================
   TABLE SCROLL
   ============================================================ */

.cpa-table-scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  scrollbar-width: thin;
}

.cpa-table-scroll::-webkit-scrollbar {
  height: 8px;
}

.cpa-table-scroll::-webkit-scrollbar-track {
  background: #f1f3f4;
}

.cpa-table-scroll::-webkit-scrollbar-thumb {
  border-radius: 99px;
  background: #c4ccd1;
}

/* ============================================================
   TABLE
   ============================================================ */

.cpa-analytics-table {
  width: max-content;
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  color: #34404a;
  font-size: 11px;
}

.cpa-analytics-table th,
.cpa-analytics-table td {
  min-width: 82px;
  padding: 11px 10px;
  border-right: 1px solid #edf0f2;
  border-bottom: 1px solid #edf0f2;
  text-align: center;
  white-space: nowrap;
}

.cpa-analytics-table th:first-child,
.cpa-analytics-table td:first-child {
  min-width: 235px;
  text-align: left;
}

.cpa-analytics-table th {
  color: #52606b;
  background: #f7f9fa;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.cpa-analytics-table thead tr:first-child th {
  height: 42px;
}

.cpa-analytics-table thead tr:last-child th {
  height: 33px;
  background: #fafbfb;
  font-size: 8px;
}

.cpa-term-group-header {
  color: var(--cpa-primary-dark) !important;
  background: var(--cpa-primary-soft) !important;
  border-bottom-color: #d2e9e6 !important;
}

.cpa-sub-header th {
  color: #68747e !important;
}

/* ============================================================
   STICKY COLUMNS
   ============================================================ */

.cpa-sticky-col {
  position: sticky;
  z-index: 3;
  background: #fff;
}

.cpa-sticky-tech {
  left: 0;
}

.cpa-sticky-reg {
  left: 235px;
}

.cpa-sticky-paid {
  left: 317px;
}

.cpa-sticky-pending {
  left: 399px;
}

.cpa-analytics-table thead .cpa-sticky-col {
  z-index: 8;
  background: #f7f9fa;
}

.cpa-analytics-table tbody tr:hover td {
  background: #fafcfc;
}

.cpa-analytics-table tbody tr:hover .cpa-sticky-col {
  background: #fafcfc;
}

/* ============================================================
   OVERALL ROW
   ============================================================ */

.cpa-overall-row td {
  background: #f5faf9;
  border-bottom-color: #dcebe8;
  font-weight: 650;
}

.cpa-overall-row .cpa-sticky-col {
  background: #f5faf9;
}

.cpa-overall-row:hover td {
  background: #f1f8f7 !important;
}

.cpa-overall-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 800;
}

.cpa-overall-dot {
  width: 7px;
  height: 7px;
  flex: 0 0 7px;
  border-radius: 50%;
  background: var(--cpa-primary);
}

.cpa-term-overall-cell {
  background: #f2f8f7 !important;
  font-weight: 750 !important;
}

/* ============================================================
   TABLE CELLS
   ============================================================ */

.cpa-cell-paid {
  color: var(--cpa-primary-dark);
  font-weight: 650;
}

.cpa-cell-pending {
  color: #a26216;
  font-weight: 600;
}

.cpa-cell-pct {
  color: #34404a;
  font-weight: 700;
}

.cpa-cell-dim {
  color: #a2abb2 !important;
  font-weight: 500 !important;
}

.cpa-strong {
  font-weight: 850 !important;
}

/* ============================================================
   TECHNOLOGY CELL
   ============================================================ */

.cpa-tech-cell {
  display: flex;
  align-items: center;
  gap: 9px;
  min-height: 52px;
}

.cpa-tech-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  overflow: hidden;
  border: 1px solid #dce3e6;
  border-radius: 8px;
  background: #f1f4f5;
  color: #56636e;
  font-size: 11px;
  font-weight: 850;
}

.cpa-tech-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cpa-tech-icon-fallback {
  position: relative;
}

.cpa-tech-icon-fallback[data-initial] {
  font-size: 0;
}

.cpa-tech-icon-fallback[data-initial]::after {
  content: attr(data-initial);
  font-size: 11px;
}

.cpa-tech-name {
  display: block;
  min-width: 0;
  max-width: 190px;
  overflow: hidden;
  color: #29353e;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: normal;
}

/* ============================================================
   TECHNOLOGY PAYMENT
   ============================================================ */

.cpa-tech-payment {
  min-width: 76px;
}

.cpa-mini-progress {
  width: 100%;
  height: 3px;
  margin-top: 5px;
  overflow: hidden;
  border-radius: 99px;
  background: #e9eeee;
}

.cpa-mini-progress div {
  height: 100%;
  border-radius: inherit;
  background: var(--cpa-primary);
}

/* ============================================================
   TABLE EMPTY / FOOTNOTE
   ============================================================ */

.cpa-table-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 28px 20px;
  color: var(--cpa-muted);
  text-align: left;
}

.cpa-table-empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: #f0f2f3;
  color: #89939c;
  font-weight: 800;
}

.cpa-table-empty strong {
  color: #4e5a64;
  font-size: 12px;
}

.cpa-table-empty p {
  margin: 3px 0 0;
  font-size: 10px;
}

.cpa-table-footnote {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  padding: 11px 15px;
  border-top: 1px solid #edf0f2;
  color: #7d8790;
  font-size: 10px;
  line-height: 1.45;
}

/* ============================================================
   META BAR
   ============================================================ */

.cpa-meta-bar {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding: 9px 2px;
  color: #929ba3;
  font-size: 9px;
}

/* ============================================================
   EMPTY STATE
   ============================================================ */

.cpa-empty-state {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  min-height: 300px;
  padding: 40px 20px;
  border: 1px dashed #d5dce0;
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.55);
  text-align: center;
}

.cpa-es-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  margin-bottom: 14px;
  border-radius: 12px;
  background: var(--cpa-primary-soft);
  color: var(--cpa-primary);
  font-size: 22px;
  font-weight: 700;
}

.cpa-es-title {
  color: #45515b;
  font-size: 13px;
  font-weight: 750;
}

.cpa-es-sub {
  max-width: 500px;
  margin-top: 6px;
  color: #929ba3;
  font-size: 11px;
}

/* ============================================================
   SKELETON
   ============================================================ */

.cpa-skeleton-wrap {
  padding-bottom: 20px;
}

.cpa-sk-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 13px;
  margin-bottom: 13px;
}

.cpa-sk-block {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  background: #e9edef;
}

.cpa-sk-block::after {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  content: "";
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.65),
    transparent
  );
  animation: cpa-shimmer 1.25s infinite;
}

@keyframes cpa-shimmer {
  100% {
    left: 100%;
  }
}

.cpa-sk-card {
  height: 132px;
}

.cpa-sk-progress {
  height: 130px;
  margin-bottom: 13px;
}

.cpa-sk-term-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 13px;
  margin-bottom: 13px;
}

.cpa-sk-term {
  height: 115px;
}

.cpa-sk-table {
  height: 300px;
}

/* ============================================================
   PRINT
   ============================================================ */

@media print {
  .cpa-app {
    padding: 0;
    background: #fff;
  }

  .cpa-panel,
  .cpa-banner,
  .cpa-selection-count {
    display: none !important;
  }

  .cpa-masthead {
    margin-bottom: 15px;
  }

  .cpa-course-context {
    box-shadow: none;
  }

  .cpa-summary-card,
  .cpa-progress-card,
  .cpa-term-card,
  .cpa-table-card {
    box-shadow: none;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .cpa-table-scroll {
    overflow: visible;
  }

  .cpa-analytics-table {
    width: 100%;
    font-size: 8px;
  }

  .cpa-sticky-col {
    position: static;
  }

  .cpa-meta-bar {
    margin-top: 10px;
  }
}

/* ============================================================
   TABLET
   ============================================================ */

@media (max-width: 1100px) {
  .cpa-app {
    padding: 22px;
  }

  .cpa-panel-grid {
    grid-template-columns: 1fr 1fr;
  }

  .cpa-actions {
    grid-column: 1 / -1;
  }

  .cpa-summary-cards {
    grid-template-columns: repeat(2, 1fr);
  }

  .cpa-sk-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ============================================================
   MOBILE
   ============================================================ */

@media (max-width: 700px) {
  .cpa-app {
    padding: 14px;
  }

  .cpa-masthead {
    flex-direction: column;
    gap: 13px;
  }

  .cpa-course-context {
    width: 100%;
    min-width: 0;
    max-width: none;
  }

  .cpa-panel {
    padding: 14px;
  }

  .cpa-panel-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .cpa-panel-grid {
    grid-template-columns: 1fr;
  }

  .cpa-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .cpa-btn-primary {
    grid-column: 1 / -1;
  }

  .cpa-btn-ghost {
    width: 100%;
  }

  .cpa-summary-cards {
    grid-template-columns: 1fr;
  }

  .cpa-summary-card {
    min-height: 105px;
  }

  .cpa-dashboard-context {
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
  }

  .cpa-dashboard-meta {
    text-align: left;
  }

  .cpa-progress-card {
    padding: 15px;
  }

  .cpa-progress-header {
    align-items: flex-start;
  }

  .cpa-pc-pct {
    font-size: 18px;
  }

  .cpa-section-header,
  .cpa-table-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .cpa-term-cards {
    grid-template-columns: 1fr;
  }

  .cpa-table-card {
    border-radius: 10px;
  }

  .cpa-table-scroll {
    max-width: 100%;
  }

  .cpa-analytics-table th:first-child,
  .cpa-analytics-table td:first-child {
    min-width: 190px;
  }

  .cpa-sticky-reg {
    left: 190px;
  }

  .cpa-sticky-paid {
    left: 272px;
  }

  .cpa-sticky-pending {
    left: 354px;
  }

  .cpa-tech-name {
    max-width: 145px;
  }

  .cpa-meta-bar {
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
  }

  .cpa-sk-cards {
    grid-template-columns: 1fr;
  }

  .cpa-sk-term-row {
    grid-template-columns: 1fr;
  }
}

/* ============================================================
   FINAL REFERENCE LAYOUT OVERRIDES
   Blue / Navy dashboard + larger, aligned table typography
   ============================================================ */

/* ---------- Overall page ---------- */
.cpa-app {
  background: #f5f8fb;
}

/* ---------- Main title ---------- */
.cpa-masthead {
  background: #173f63;
  min-height: 58px;
  margin: -28px -28px 22px;
  padding: 0 28px;
  align-items: center;
}

.cpa-masthead h1 {
  color: #ffffff;
  font-size: clamp(22px, 2.6vw, 30px);
  font-weight: 800;
  letter-spacing: -0.02em;
}

.cpa-eyebrow {
  color: #dcecf8;
}

.cpa-sub {
  color: rgba(255, 255, 255, 0.82);
}

/* ---------- Course context ---------- */
.cpa-course-context {
  border-color: #d7d7d7;
  border-radius: 6px;
  box-shadow: none;
}

.cpa-cmeta {
  color: #347cb5;
}

/* ---------- Controls ---------- */
.cpa-panel {
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(23, 63, 99, 0.06);
}

.cpa-control:focus,
.cpa-term-trigger:focus {
  border-color: #347cb5;
  box-shadow: 0 0 0 3px rgba(52, 124, 181, 0.12);
}

.cpa-btn-primary {
  border-color: #347cb5;
  background: #347cb5;
  box-shadow: 0 3px 8px rgba(52, 124, 181, 0.18);
}

.cpa-btn-primary:hover:not(:disabled) {
  background: #286a9f;
}

.cpa-btn-ghost {
  border-color: #c5ddec;
  background: #dcecf8;
  color: #173f63;
}

/* ---------- Summary cards ---------- */
.cpa-summary-cards {
  gap: 0;
  margin-bottom: 0;
  overflow: hidden;
}

.cpa-summary-card {
  min-height: 88px;
  padding: 12px 14px;
  border: 1px solid rgba(255,255,255,0.35);
  border-radius: 0;
  background: #347cb5;
  color: #ffffff;
  box-shadow: none;
  align-items: center;
}

.cpa-summary-card.cpa-primary-metric {
  border-color: rgba(255,255,255,0.35);
  box-shadow: none;
}

.cpa-sc-icon {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
}

.cpa-summary-card .cpa-sc-label {
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
}

.cpa-summary-card .cpa-sc-value {
  margin-top: 4px;
  color: #ffffff;
  font-size: 24px;
  font-weight: 800;
}

.cpa-summary-card .cpa-sc-desc {
  color: rgba(255,255,255,0.82);
}

.cpa-summary-card.cpa-pending {
  background: #6ead4f;
}

.cpa-summary-card .cpa-icon-neutral,
.cpa-summary-card .cpa-icon-paid,
.cpa-summary-card .cpa-icon-pending,
.cpa-summary-card .cpa-icon-pct {
  background: rgba(255,255,255,0.14);
  color: #ffffff;
}

/* ---------- Progress ---------- */
.cpa-progress-card {
  margin-bottom: 18px;
  border-radius: 0 0 6px 6px;
  box-shadow: none;
}

.cpa-progress-fill {
  background: #347cb5;
}

/* ---------- Section headings ---------- */
.cpa-section-title,
.cpa-pc-title,
.cpa-dashboard-course {
  color: #173f63;
}

.cpa-section-kicker,
.cpa-dashboard-term-line span {
  color: #347cb5;
}

/* ---------- Term cards ---------- */
.cpa-term-card {
  border-radius: 6px;
  border-top: 3px solid #347cb5;
  box-shadow: none;
}

.cpa-tc-percent,
.cpa-tc-paid {
  color: #347cb5;
}

.cpa-tc-pending {
  color: #5f8f43;
}

.cpa-tc-progress-fill {
  background: #347cb5;
}

/* ============================================================
   MAIN ANALYTICS TABLE
   ============================================================ */

.cpa-table-card {
  border-radius: 6px;
  box-shadow: none;
}

.cpa-table-heading {
  padding: 13px 16px;
  background: #ffffff;
}

.cpa-analytics-table {
  font-size: 15px;
  color: #17202a;
}

.cpa-analytics-table th,
.cpa-analytics-table td {
  min-width: 82px;
  height: 44px;
  padding: 9px 10px;
  border-right: 1px solid #d7d7d7;
  border-bottom: 1px solid #d7d7d7;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
}

/* Batch / Technology */
.cpa-analytics-table th:first-child,
.cpa-analytics-table td:first-child {
  min-width: 250px;
  text-align: center;
}

.cpa-analytics-table th {
  height: 42px;
  color: #ffffff;
  background: #347cb5;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: none;
}

.cpa-analytics-table thead tr:first-child th,
.cpa-analytics-table thead tr:last-child th {
  height: 42px;
  background: #347cb5;
  color: #ffffff;
  font-size: 14px;
}

/* Term group headers */
.cpa-term-group-header {
  background: #286a9f !important;
  color: #ffffff !important;
  border-bottom-color: #d7d7d7 !important;
}

.cpa-sub-header th {
  background: #347cb5 !important;
  color: #ffffff !important;
}

/* ---------- Sticky columns ---------- */
.cpa-sticky-col {
  background: #ffffff;
}

.cpa-analytics-table thead .cpa-sticky-col {
  background: #347cb5;
}

.cpa-sticky-reg {
  left: 250px;
}

.cpa-sticky-paid {
  left: 332px;
}

.cpa-sticky-pending {
  left: 414px;
}

/* ---------- Technology cell ---------- */
.cpa-tech-cell {
  min-height: 44px;
  justify-content: center;
  text-align: center;
}

.cpa-tech-name {
  max-width: 205px;
  color: #17202a;
  font-size: 15px;
  font-weight: 650;
  line-height: 1.3;
  text-align: center;
}

/* ---------- Registration ---------- */
.cpa-analytics-table td:nth-child(2),
.cpa-analytics-table th:nth-child(2) {
  text-align: center !important;
  font-size: 15px;
  font-weight: 650;
}

/* ---------- PAID: explicit center alignment ---------- */
.cpa-analytics-table td:nth-child(3),
.cpa-analytics-table th:nth-child(3),
.cpa-cell-paid,
.cpa-sticky-paid {
  text-align: center !important;
  vertical-align: middle !important;
}

.cpa-cell-paid {
  color: #173f63;
  font-size: 16px;
  font-weight: 750;
  line-height: 1.2;
}

/* ---------- PENDING ---------- */
.cpa-analytics-table td:nth-child(4),
.cpa-analytics-table th:nth-child(4),
.cpa-cell-pending,
.cpa-sticky-pending {
  text-align: center !important;
  vertical-align: middle !important;
}

.cpa-cell-pending {
  color: #34404a;
  font-size: 16px;
  font-weight: 650;
  line-height: 1.2;
}

/* ---------- Percentages ---------- */
.cpa-cell-pct {
  color: #173f63;
  font-size: 15px;
  font-weight: 750;
  text-align: center !important;
  vertical-align: middle !important;
}

/* ---------- Overall row ---------- */
.cpa-overall-row td {
  height: 46px;
  background: #dcecf8;
  color: #173f63;
  font-size: 15px;
  font-weight: 750;
  border-bottom-color: #bfdced;
}

.cpa-overall-row .cpa-sticky-col {
  background: #dcecf8;
}

.cpa-overall-row:hover td {
  background: #dcecf8 !important;
}

.cpa-overall-label {
  justify-content: center;
  color: #173f63;
  font-size: 15px;
  font-weight: 800;
}

.cpa-overall-dot {
  background: #347cb5;
}

.cpa-term-overall-cell {
  background: #dcecf8 !important;
}

/* ---------- Table progress bars ---------- */
.cpa-mini-progress {
  height: 5px;
  background: #e4eef5;
}

.cpa-mini-progress div {
  background: #347cb5;
}

/* ---------- Table empty ---------- */
.cpa-table-empty {
  font-size: 13px;
}

/* ============================================================
   RESPONSIVE STICKY OFFSETS
   ============================================================ */

@media (max-width: 700px) {
  .cpa-masthead {
    margin: -14px -14px 18px;
    padding: 0 14px;
  }

  .cpa-analytics-table {
    font-size: 14px;
  }

  .cpa-analytics-table th,
  .cpa-analytics-table td {
    height: 42px;
    padding: 8px 9px;
  }

  .cpa-analytics-table th:first-child,
  .cpa-analytics-table td:first-child {
    min-width: 205px;
  }

  .cpa-sticky-reg {
    left: 205px;
  }

  .cpa-sticky-paid {
    left: 287px;
  }

  .cpa-sticky-pending {
    left: 369px;
  }

  .cpa-tech-name {
    max-width: 160px;
    font-size: 14px;
  }

  .cpa-cell-paid,
  .cpa-cell-pending {
    font-size: 15px;
  }
}

/* ============================================================
   COMPACT DASHBOARD LAYOUT
   Remove Overall Payment Progress + reduce unnecessary spacing
   ============================================================ */

/* ------------------------------------------------------------
   1. REMOVE OVERALL PAYMENT PROGRESS SECTION
   ------------------------------------------------------------ */

.cpa-progress-card {
    display: none !important;
}


/* ------------------------------------------------------------
   2. REMOVE EXTRA SPACE BEFORE TERM-WISE SECTION
   ------------------------------------------------------------ */

.cpa-section {
    margin-bottom: 14px;
}

.cpa-section-header {
    margin-bottom: 8px;
}


/* ------------------------------------------------------------
   3. TERM-WISE SECTION
   Make it immediately follow the previous section
   ------------------------------------------------------------ */

.cpa-section:has(.cpa-term-cards) {
    margin-top: 0 !important;
    padding-top: 0 !important;
}


/* ------------------------------------------------------------
   4. TERM CARDS
   Equal width, compact spacing
   ------------------------------------------------------------ */

.cpa-term-cards {
    display: grid;

    grid-template-columns:
        repeat(2, minmax(0, 1fr));

    gap: 10px;

    width: 100%;

    margin: 0;

    padding: 0;
}


/* ------------------------------------------------------------
   5. INDIVIDUAL TERM CARD
   ------------------------------------------------------------ */

.cpa-term-card {
    width: 100%;

    min-width: 0;

    margin: 0;

    padding: 12px 14px;

    border: 1px solid #d7d7d7;

    border-top: 3px solid #347cb5;

    border-radius: 5px;

    background: #ffffff;

    box-shadow: none;

    box-sizing: border-box;
}


/* ------------------------------------------------------------
   6. TERM HEADER
   ------------------------------------------------------------ */

.cpa-tc-header {
    display: flex;

    align-items: center;

    justify-content: space-between;

    gap: 10px;

    padding: 0 0 8px;

    border-bottom: 1px solid #e5e9ed;
}


/* Term name */
.cpa-tc-name {
    margin: 0;

    color: #173f63;

    font-size: 14px;

    font-weight: 700;

    line-height: 1.2;
}


/* Percentage */
.cpa-tc-percent {
    margin: 0;

    color: #347cb5;

    font-size: 14px;

    font-weight: 800;

    line-height: 1.2;
}


/* ------------------------------------------------------------
   7. TERM CARD CONTENT
   ------------------------------------------------------------ */

.cpa-tc-main {
    display: flex;

    align-items: center;

    gap: 28px;

    padding: 10px 0 8px;

    margin: 0;
}


/* ------------------------------------------------------------
   8. PAID / PENDING
   ------------------------------------------------------------ */

.cpa-tc-stat {
    display: flex;

    flex-direction: column;

    justify-content: center;

    gap: 3px;

    min-width: 55px;

    margin: 0;
}


.cpa-tc-stat-label {
    margin: 0;

    color: #7b8791;

    font-size: 9px;

    font-weight: 800;

    line-height: 1.1;

    text-transform: uppercase;
}


.cpa-tc-stat strong {
    margin: 0;

    font-size: 20px;

    font-weight: 800;

    line-height: 1;
}


/* Paid */
.cpa-tc-paid {
    color: #286a9f;
}


/* Pending */
.cpa-tc-pending {
    color: #5d963f;
}


/* ------------------------------------------------------------
   9. DIVIDER BETWEEN PAID AND PENDING
   ------------------------------------------------------------ */

.cpa-tc-divider {
    width: 1px;

    height: 34px;

    flex: 0 0 1px;

    margin: 0;

    background: #dfe4e8;
}


/* ------------------------------------------------------------
   10. TERM PROGRESS BAR
   ------------------------------------------------------------ */

.cpa-tc-progress-track {
    width: 100%;

    height: 5px;

    margin: 0;

    overflow: hidden;

    border-radius: 3px;

    background: #e8edf1;
}


.cpa-tc-progress-fill {
    height: 100%;

    margin: 0;

    border-radius: 3px;

    background: #347cb5;
}


/* ------------------------------------------------------------
   11. REMOVE EMPTY TERM CARD SPACE
   ------------------------------------------------------------ */

.cpa-term-cards-empty {
    margin: 0;

    padding: 14px;

    border-radius: 5px;
}


/* ============================================================
   12. SECTION TITLE — COMPACT
   ============================================================ */

.cpa-section-header {
    display: flex;

    align-items: center;

    justify-content: space-between;

    gap: 10px;

    margin-top: 0;

    margin-bottom: 8px;

    padding: 0;
}


.cpa-section-title {
    margin: 0;

    color: #173f63;

    font-size: 16px;

    font-weight: 750;

    line-height: 1.2;
}


/* Small "Individual term results" label */
.cpa-section-header .cpa-tag {
    margin: 0;

    padding: 4px 7px;

    font-size: 9px;
}


/* ============================================================
   13. DASHBOARD CONTEXT — REMOVE EXTRA SPACE
   ============================================================ */

.cpa-dashboard-context {
    margin-bottom: 10px;

    gap: 10px;
}


/* ============================================================
   14. TERM SECTION ITSELF
   ============================================================ */

.cpa-section:has(.cpa-term-cards) {
    margin-bottom: 14px;
}


/* ============================================================
   15. TABLE SHOULD FOLLOW TERM CARDS CLOSELY
   ============================================================ */

.cpa-table-card {
    margin-top: 0;

    margin-bottom: 14px;
}


/* ============================================================
   16. RESPONSIVE
   ============================================================ */

@media (max-width: 700px) {

    .cpa-term-cards {
        grid-template-columns: 1fr;

        gap: 8px;
    }

    .cpa-term-card {
        padding: 11px 12px;
    }

    .cpa-tc-main {
        gap: 20px;
    }
}


/* ============================================================
   17. VERY SMALL SCREENS
   ============================================================ */

@media (max-width: 420px) {

    .cpa-tc-main {
        gap: 16px;
    }

    .cpa-tc-stat {
        min-width: 48px;
    }

    .cpa-tc-stat strong {
        font-size: 18px;
    }

    .cpa-tc-name,
    .cpa-tc-percent {
        font-size: 13px;
    }
}

/* ============================================================
   FIX TERM-WISE PAID COLUMN WIDTH
   Keep Batch column wide, but Term Paid column compact
   ============================================================ */

/* Batch / Technology column stays wide */
.cpa-analytics-table thead tr:first-child th:first-child {
    min-width: 250px;
    width: 250px;
}

/* Second header row:
   Paid must NOT inherit the Batch column width */
.cpa-analytics-table .cpa-sub-header th:first-child {
    min-width: 82px !important;
    width: 82px !important;
    max-width: 82px !important;

    padding-left: 8px !important;
    padding-right: 8px !important;

    text-align: center !important;
}

/* All Term-wise numeric columns remain compact */
.cpa-analytics-table .cpa-sub-header th {
    min-width: 82px !important;
    width: 82px !important;
    max-width: 100px;
}

/* Term 1 Paid body cells */
.cpa-analytics-table td.cpa-cell-paid {
    min-width: 82px !important;
    width: 82px !important;
    max-width: 100px !important;

    padding-left: 6px !important;
    padding-right: 6px !important;

    text-align: center !important;
}

/* Keep Paid number centered */
.cpa-cell-paid {
    display: table-cell;

    text-align: center !important;
    vertical-align: middle !important;

    font-size: 15px !important;
    font-weight: 750 !important;
}

/* Term-wise columns */
.cpa-analytics-table td.cpa-cell-pending,
.cpa-analytics-table td.cpa-cell-pct,
.cpa-analytics-table td.cpa-cell-share {
    min-width: 82px !important;

    padding-left: 6px !important;
    padding-right: 6px !important;

    text-align: center !important;
}


/* ============================================================
   PREVENT FIRST-CHILD RULE FROM AFFECTING TERM HEADERS
   ============================================================ */

.cpa-analytics-table .cpa-sub-header th:first-child {
    min-width: 82px !important;
    width: 82px !important;
}


/* ============================================================
   TERM GROUPS — CONSISTENT COLUMN WIDTH
   ============================================================ */

.cpa-analytics-table th,
.cpa-analytics-table td {
    box-sizing: border-box;
}

.cpa-analytics-table .cpa-term-group-header {
    text-align: center !important;
    vertical-align: middle !important;
}


/* ============================================================
   IF STICKY PAID COLUMN IS USED
   ============================================================ */

.cpa-sticky-paid {
    left: 332px;
    min-width: 82px !important;
    width: 82px !important;
}


/* ============================================================
   MOBILE
   ============================================================ */

@media (max-width: 700px) {

    .cpa-analytics-table .cpa-sub-header th:first-child {
        min-width: 76px !important;
        width: 76px !important;
    }

    .cpa-analytics-table td.cpa-cell-paid {
        min-width: 76px !important;
        width: 76px !important;
    }
}

/* ============================================================
   HEADER + COURSE NAME — FINAL TYPOGRAPHY UPDATE
   ============================================================ */

.cpa-masthead {
    background: #173f63;

    min-height: 68px;

    margin: -28px -28px 20px;

    padding: 10px 28px;

    display: flex;

    align-items: center;

    box-sizing: border-box;
}


/* Main dashboard title */
.cpa-masthead h1 {
    margin: 0;

    color: #ffffff;

    font-size: 27px !important;

    font-weight: 800 !important;

    line-height: 1.2;

    letter-spacing: 0;

    white-space: nowrap;
}


/* ============================================================
   COURSE NAME
   ============================================================ */

.cpa-dashboard-context {
    margin-top: 0 !important;

    margin-bottom: 16px !important;

    padding: 0 !important;

    display: flex;

    align-items: center;

    gap: 8px;
}


/* Course name itself */
.cpa-dashboard-course {
    color: #173f63 !important;

    font-size: 21px !important;

    font-weight: 800 !important;

    line-height: 1.25;

    margin: 0 !important;
}


/* Course metadata / selected terms */
.cpa-dashboard-term-line {
    margin-top: 4px;

    color: #52606d;

    font-size: 14px !important;

    font-weight: 500;

    line-height: 1.3;
}


/* Small labels inside course context */
.cpa-dashboard-term-line span {
    color: #347cb5;

    font-size: 13px !important;

    font-weight: 700;
}


/* ============================================================
   SECTION TITLES
   ============================================================ */

.cpa-section-title {
    color: #173f63 !important;

    font-size: 19px !important;

    font-weight: 800 !important;

    line-height: 1.25;

    margin: 0 !important;
}


/* Section small heading / kicker */
.cpa-section-kicker {
    color: #347cb5 !important;

    font-size: 12px !important;

    font-weight: 800 !important;

    letter-spacing: 0.08em;

    text-transform: uppercase;

    margin-bottom: 3px;
}


/* ============================================================
   SUMMARY CARD FONT SIZES
   ============================================================ */

.cpa-summary-card .cpa-sc-label {
    color: #ffffff;

    font-size: 15px !important;

    font-weight: 800 !important;
}

.cpa-summary-card .cpa-sc-value {
    color: #ffffff;

    font-size: 25px !important;

    font-weight: 800 !important;

    line-height: 1.1;
}

.cpa-summary-card .cpa-sc-desc {
    font-size: 12px !important;
}


/* ============================================================
   TERM CARD FONT SIZES
   ============================================================ */

.cpa-tc-name {
    font-size: 15px !important;

    font-weight: 800 !important;
}

.cpa-tc-percent {
    font-size: 15px !important;

    font-weight: 800 !important;
}

.cpa-tc-stat-label {
    font-size: 10px !important;

    font-weight: 800 !important;
}

.cpa-tc-stat strong {
    font-size: 21px !important;

    font-weight: 800 !important;
}


/* ============================================================
   TABLE FONT SIZES
   ============================================================ */

.cpa-analytics-table th {
    font-size: 15px !important;

    font-weight: 800 !important;
}

.cpa-analytics-table td {
    font-size: 15px !important;

    font-weight: 600;
}


/* Batch / technology name */
.cpa-tech-name {
    font-size: 16px !important;

    font-weight: 700 !important;
}


/* Paid */
.cpa-cell-paid {
    font-size: 17px !important;

    font-weight: 800 !important;

    text-align: center !important;

    vertical-align: middle !important;
}


/* Pending */
.cpa-cell-pending {
    font-size: 17px !important;

    font-weight: 700 !important;

    text-align: center !important;

    vertical-align: middle !important;
}


/* Payment % */
.cpa-cell-pct {
    font-size: 16px !important;

    font-weight: 800 !important;

    text-align: center !important;
}


/* Overall row */
.cpa-overall-row td {
    font-size: 16px !important;

    font-weight: 800 !important;
}


/* ============================================================
   MOBILE
   ============================================================ */

@media (max-width: 700px) {

    .cpa-masthead {
        min-height: 62px;

        margin: -14px -14px 16px;

        padding: 10px 14px;
    }

    .cpa-masthead h1 {
        font-size: 21px !important;

        white-space: normal;
    }

    .cpa-dashboard-course {
        font-size: 18px !important;
    }

    .cpa-section-title {
        font-size: 17px !important;
    }

    .cpa-analytics-table th {
        font-size: 14px !important;
    }

    .cpa-analytics-table td {
        font-size: 14px !important;
    }

    .cpa-cell-paid,
    .cpa-cell-pending {
        font-size: 16px !important;
    }
}

/* ============================================================
   FINAL UI UPDATE
   - Match the provided DRIVE READY 2028 header reference
   - Larger typography without making it excessively bold
   - Larger course name
   - Remove A/B/C/D/F/M technology initials
   - Overall Share shows a meaningful 100.00%
   - Preserve compact table alignment
   ============================================================ */


/* ============================================================
   1. MAIN HEADER — MATCH REFERENCE IMAGE
   ============================================================ */

.cpa-masthead {
    display: flex;
    align-items: center;

    min-height: 58px;

    margin: -28px -28px 18px;

    padding: 0 22px;

    background: #173f63;

    border-bottom: 4px solid #dcecf8;

    box-sizing: border-box;
}


/* Main title */
.cpa-masthead h1 {
    margin: 0 !important;

    color: #ffffff !important;

    font-size: 30px !important;

    font-weight: 700 !important;

    letter-spacing: 0 !important;

    line-height: 1.15 !important;

    white-space: nowrap;
}


/* Hide the small eyebrow if it is displayed above the title.
   The reference image is a clean single-line title. */
.cpa-eyebrow {
    display: none;
}


/* Do not show the old subtitle inside the blue header */
.cpa-masthead .cpa-sub {
    display: none;
}


/* ============================================================
   2. COURSE NAME — BIGGER BUT NOT HEAVY
   ============================================================ */

.cpa-dashboard-context {
    display: flex;

    align-items: flex-start;

    justify-content: space-between;

    gap: 20px;

    margin-top: 0 !important;

    margin-bottom: 12px !important;

    padding: 0 !important;
}


.cpa-dashboard-course {
    margin: 0 !important;

    color: #173f63 !important;

    font-size: 24px !important;

    font-weight: 650 !important;

    letter-spacing: -0.01em !important;

    line-height: 1.2 !important;
}


/* Selected terms */
.cpa-dashboard-term-line {
    margin-top: 5px !important;

    color: #52606d !important;

    font-size: 13px !important;

    font-weight: 500 !important;

    line-height: 1.3 !important;
}


.cpa-dashboard-term-line span {
    color: #347cb5 !important;

    font-size: 13px !important;

    font-weight: 600 !important;
}


/* Last updated text */
.cpa-dashboard-meta {
    color: #7b8791 !important;

    font-size: 10px !important;

    font-weight: 400 !important;

    text-align: right;
}


/* ============================================================
   3. REMOVE TECHNOLOGY INITIAL BOXES
   A / C / D / F / M etc.
   ============================================================ */

.cpa-tech-icon {
    display: none !important;
}


/* Remove the gap that was reserved for the icon */
.cpa-tech-cell {
    display: flex;

    align-items: center;

    justify-content: center;

    gap: 0 !important;

    min-height: 48px;

    padding-left: 8px;

    padding-right: 8px;
}


/* Technology name */
.cpa-tech-name {
    display: block;

    max-width: 225px;

    overflow: hidden;

    color: #173f63 !important;

    font-size: 15px !important;

    font-weight: 600 !important;

    line-height: 1.25 !important;

    text-align: center;

    text-overflow: ellipsis;

    white-space: normal;
}


/* ============================================================
   4. GENERAL TYPOGRAPHY
   Larger font size, controlled weight
   ============================================================ */

.cpa-summary-card .cpa-sc-label {
    font-size: 15px !important;

    font-weight: 600 !important;
}


.cpa-summary-card .cpa-sc-value {
    font-size: 26px !important;

    font-weight: 700 !important;
}


.cpa-summary-card .cpa-sc-desc {
    font-size: 12px !important;

    font-weight: 400 !important;
}


.cpa-section-kicker {
    font-size: 11px !important;

    font-weight: 700 !important;
}


.cpa-section-title {
    font-size: 18px !important;

    font-weight: 650 !important;
}


/* ============================================================
   5. TERM CARDS
   ============================================================ */

.cpa-tc-name {
    font-size: 15px !important;

    font-weight: 650 !important;
}


.cpa-tc-percent {
    font-size: 15px !important;

    font-weight: 650 !important;
}


.cpa-tc-stat-label {
    font-size: 10px !important;

    font-weight: 600 !important;
}


.cpa-tc-stat strong {
    font-size: 21px !important;

    font-weight: 650 !important;
}


/* ============================================================
   6. TABLE — BIGGER FONT, NOT EXTRA BOLD
   ============================================================ */

.cpa-analytics-table {
    font-size: 14px !important;
}


.cpa-analytics-table th,
.cpa-analytics-table td {
    font-size: 14px !important;

    font-weight: 500;

    vertical-align: middle !important;
}


/* Header */
.cpa-analytics-table th {
    font-size: 14px !important;

    font-weight: 650 !important;
}


/* Technology / Batch header */
.cpa-analytics-table th:first-child {
    font-size: 14px !important;

    font-weight: 650 !important;
}


/* Registrations */
.cpa-analytics-table td:nth-child(2) {
    font-size: 15px !important;

    font-weight: 550 !important;

    text-align: center !important;
}


/* Common Paid */
.cpa-analytics-table td:nth-child(3) {
    font-size: 15px !important;

    font-weight: 600 !important;

    text-align: center !important;
}


/* Common Pending */
.cpa-analytics-table td:nth-child(4) {
    font-size: 15px !important;

    font-weight: 550 !important;

    text-align: center !important;
}


/* Payment % */
.cpa-cell-pct {
    font-size: 15px !important;

    font-weight: 600 !important;

    text-align: center !important;

    vertical-align: middle !important;
}


/* Paid */
.cpa-cell-paid {
    font-size: 16px !important;

    font-weight: 600 !important;

    text-align: center !important;

    vertical-align: middle !important;
}


/* Pending */
.cpa-cell-pending {
    font-size: 16px !important;

    font-weight: 550 !important;

    text-align: center !important;

    vertical-align: middle !important;
}


/* Share */
.cpa-cell-share {
    font-size: 15px !important;

    font-weight: 500 !important;

    text-align: center !important;

    vertical-align: middle !important;
}


/* ============================================================
   7. OVERALL ROW
   ============================================================ */

.cpa-overall-row td {
    font-size: 15px !important;

    font-weight: 650 !important;
}


/* Overall label */
.cpa-overall-label {
    font-size: 15px !important;

    font-weight: 650 !important;
}


/* ------------------------------------------------------------
   Overall Share:
   Instead of displaying "-" show 100.00%.

   The Overall row represents the full course total,
   therefore its share is 100%.
   ------------------------------------------------------------ */

.cpa-overall-row > td:nth-child(6) {
    font-size: 0 !important;

    text-align: center !important;
}


.cpa-overall-row > td:nth-child(6)::after {
    content: "100.00%";

    color: #173f63;

    font-size: 15px;

    font-weight: 650;
}


/* ============================================================
   8. TERM OVERALL CELLS
   ============================================================ */

.cpa-term-overall-cell {
    font-size: 15px !important;

    font-weight: 650 !important;

    text-align: center !important;
}


/* ============================================================
   9. TABLE HEIGHT / SPACING
   ============================================================ */

.cpa-analytics-table th,
.cpa-analytics-table td {
    min-height: 44px;

    padding-top: 9px !important;

    padding-bottom: 9px !important;
}


.cpa-tech-cell {
    min-height: 44px !important;
}


/* ============================================================
   10. TERM CARDS — KEEP COMPACT
   ============================================================ */

.cpa-term-cards {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;

    gap: 10px !important;

    margin: 0 !important;
}


.cpa-term-card {
    padding: 12px 14px !important;

    border-radius: 5px !important;

    box-shadow: none !important;
}


/* ============================================================
   11. SUMMARY CARDS — REFERENCE BLUE
   ============================================================ */

.cpa-summary-cards {
    gap: 0 !important;

    margin-bottom: 0 !important;
}


.cpa-summary-card {
    min-height: 92px !important;

    padding: 12px 16px !important;

    border-radius: 0 !important;

    background: #347cb5 !important;

    color: #ffffff !important;

    box-shadow: none !important;
}


.cpa-summary-card.cpa-pending {
    background: #6ead4f !important;
}


/* ============================================================
   12. REMOVE OVERALL PROGRESS
   ============================================================ */

.cpa-progress-card {
    display: none !important;
}


/* ============================================================
   13. SECTION SPACING
   ============================================================ */

.cpa-section {
    margin-bottom: 12px !important;
}


.cpa-section-header {
    margin-bottom: 7px !important;
}


/* ============================================================
   14. TABLE HEADING
   ============================================================ */

.cpa-table-heading {
    padding: 12px 14px !important;
}


.cpa-table-caption {
    font-size: 10px !important;

    font-weight: 500 !important;
}


/* ============================================================
   15. DESKTOP HEADER WIDTH
   ============================================================ */

@media (min-width: 1101px) {

    .cpa-masthead h1 {
        font-size: 30px !important;
    }

    .cpa-dashboard-course {
        font-size: 25px !important;
    }
}


/* ============================================================
   16. TABLET
   ============================================================ */

@media (max-width: 1100px) {

    .cpa-masthead h1 {
        font-size: 27px !important;
    }

    .cpa-dashboard-course {
        font-size: 22px !important;
    }

    .cpa-tech-name {
        font-size: 14px !important;
    }
}


/* ============================================================
   17. MOBILE
   ============================================================ */

@media (max-width: 700px) {

    .cpa-masthead {
        min-height: 54px;

        margin: -14px -14px 16px;

        padding: 0 14px;

        border-bottom-width: 3px;
    }


    .cpa-masthead h1 {
        font-size: 21px !important;

        line-height: 1.15 !important;

        white-space: normal;
    }


    .cpa-dashboard-course {
        font-size: 20px !important;
    }


    .cpa-dashboard-term-line {
        font-size: 12px !important;
    }


    .cpa-section-title {
        font-size: 17px !important;
    }


    .cpa-tech-name {
        max-width: 180px;

        font-size: 14px !important;
    }


    .cpa-analytics-table th,
    .cpa-analytics-table td {
        font-size: 13px !important;
    }


    .cpa-cell-paid,
    .cpa-cell-pending {
        font-size: 14px !important;
    }


    .cpa-term-cards {
        grid-template-columns: 1fr !important;
    }
}


/* ============================================================
   18. VERY SMALL MOBILE
   ============================================================ */

@media (max-width: 420px) {

    .cpa-masthead h1 {
        font-size: 18px !important;
    }


    .cpa-dashboard-course {
        font-size: 18px !important;
    }


    .cpa-tech-name {
        max-width: 150px;

        font-size: 13px !important;
    }
}

/* ============================================================
   TERM MULTI SELECT - FIX
   ============================================================ */

.cpa-term-select {
    position: relative;
    width: 100%;
    z-index: 1000;
}

.cpa-term-trigger {
    width: 100%;
    min-height: 46px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 0 14px;

    border: 1px solid #d7dce5;
    border-radius: 8px;

    background: #ffffff;
    color: #1f2937;

    font-size: 14px;
    font-weight: 500;

    cursor: pointer;

    position: relative;
    z-index: 1001;
}

.cpa-term-trigger:hover {
    border-color: #b9c2d0;
}

.cpa-term-trigger:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.10);
}

.cpa-term-trigger:disabled {
    cursor: not-allowed;
    opacity: 0.65;
}

.cpa-term-trigger-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.cpa-chev {
    flex-shrink: 0;
    margin-left: 10px;
    font-size: 14px;
}

/* ============================================================
   DROPDOWN
   ============================================================ */

.cpa-term-dropdown {
    position: absolute;

    top: calc(100% + 6px);
    left: 0;
    right: 0;

    width: 100%;
    min-width: 240px;

    background: #ffffff;

    border: 1px solid #d9dee7;
    border-radius: 9px;

    box-shadow:
        0 14px 35px rgba(15, 23, 42, 0.16);

    z-index: 999999;

    overflow: hidden;
}

/* ============================================================
   SELECT ALL / CLEAR ALL
   ============================================================ */

.cpa-term-dropdown-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 9px 12px;

    background: #f8fafc;

    border-bottom: 1px solid #e5e7eb;
}

.cpa-term-dropdown-actions button {
    border: none;
    background: transparent;

    color: #2563eb;

    font-size: 12px;
    font-weight: 600;

    padding: 5px 7px;

    cursor: pointer;
}

.cpa-term-dropdown-actions button:hover {
    text-decoration: underline;
}

.cpa-term-dropdown-actions button:disabled {
    color: #9ca3af;
    cursor: not-allowed;
    text-decoration: none;
}

/* ============================================================
   TERM OPTIONS
   ============================================================ */

.cpa-term-options {
    width: 100%;

    max-height: 240px;

    overflow-y: auto;

    padding: 5px 0;

    background: #ffffff;
}

.cpa-term-option {
    display: flex;
    align-items: center;

    width: 100%;

    gap: 10px;

    padding: 10px 14px;

    background: #ffffff;

    color: #1f2937;

    font-size: 13px;
    font-weight: 500;

    cursor: pointer;

    box-sizing: border-box;
}

.cpa-term-option:hover {
    background: #f3f6fa;
}

.cpa-term-option input[type="checkbox"] {
    width: 16px;
    height: 16px;

    margin: 0;

    flex-shrink: 0;

    cursor: pointer;

    accent-color: #2563eb;
}

.cpa-term-option span {
    display: block;

    color: #1f2937;

    font-size: 13px;
    font-weight: 500;

    opacity: 1;
    visibility: visible;
}

/* ============================================================
   EMPTY
   ============================================================ */

.cpa-term-empty {
    padding: 15px;

    text-align: center;

    color: #64748b;

    font-size: 12px;
}

/* ============================================================
   FOOTER
   ============================================================ */

.cpa-term-dropdown-footer {
    padding: 8px 12px;

    border-top: 1px solid #e5e7eb;

    background: #f8fafc;

    color: #64748b;

    font-size: 11px;
    font-weight: 600;
}

/* ============================================================
   IMPORTANT: PREVENT DROPDOWN CLIPPING
   ============================================================ */

.cpa-panel {
    position: relative;
    z-index: 20;

    overflow: visible !important;
}

.cpa-panel-grid {
    position: relative;
    z-index: 20;

    overflow: visible !important;
}

.cpa-field {
    position: relative;

    overflow: visible !important;
}

.cpa-terms-field {
    position: relative;
    z-index: 1000;
}

.cpa-actions {
    position: relative;
    z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/pages/CourseTechPanel/PaymentsAnalyticsDashboard.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;EACE,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,+CAA+C;;EAE/C,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB;;;;;cAKY;AACd;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd;;;aAGW;EACX,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;iEAEiE;;AAEjE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;EACnC,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb;;;QAGM;EACN,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;yBAEuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;iEAEiE;;AAEjE;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf;;yBAEuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB;;qCAEmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf;;;;2BAIyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;iEAEiE;;AAEjE;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB;sCACoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;iEAEiE;;AAEjE;EACE,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;;iEAEiE;;AAEjE;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb;;;GAGC;EACD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;iEAEiE;;AAEjE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;iEAEiE;;AAEjE;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;iEAEiE;;AAEjE;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;iEAEiE;;AAEjE;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iEAEiE;;AAEjE;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;iEAEiE;;AAEjE;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;iEAEiE;;AAEjE;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;iEAEiE;;AAEjE;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,WAAW;EACX;;;;;GAKC;EACD,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;IAIE,gBAAgB;IAChB,wBAAmB;IAAnB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;iEAGiE;;AAEjE,uCAAuC;AACvC;EACE,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,yCAAyC;AACzC;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,MAAM;EACN,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iEAEiE;;AAEjE;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;;EAEE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;;;;EAIE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;;;;EAIE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA,sCAAsC;AACtC;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,eAAe;AACjB;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,wBAAwB;IACxB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;;;iEAGiE;;AAEjE;;iEAEiE;;AAEjE;IACI,wBAAwB;AAC5B;;;AAGA;;iEAEiE;;AAEjE;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;;;iEAGiE;;AAEjE;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;;AAGA;;;iEAGiE;;AAEjE;IACI,aAAa;;IAEb;iCAC6B;;IAE7B,SAAS;;IAET,WAAW;;IAEX,SAAS;;IAET,UAAU;AACd;;;AAGA;;iEAEiE;;AAEjE;IACI,WAAW;;IAEX,YAAY;;IAEZ,SAAS;;IAET,kBAAkB;;IAElB,yBAAyB;;IAEzB,6BAA6B;;IAE7B,kBAAkB;;IAElB,mBAAmB;;IAEnB,gBAAgB;;IAEhB,sBAAsB;AAC1B;;;AAGA;;iEAEiE;;AAEjE;IACI,aAAa;;IAEb,mBAAmB;;IAEnB,8BAA8B;;IAE9B,SAAS;;IAET,gBAAgB;;IAEhB,gCAAgC;AACpC;;;AAGA,cAAc;AACd;IACI,SAAS;;IAET,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;;IAEhB,gBAAgB;AACpB;;;AAGA,eAAe;AACf;IACI,SAAS;;IAET,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;;IAEhB,gBAAgB;AACpB;;;AAGA;;iEAEiE;;AAEjE;IACI,aAAa;;IAEb,mBAAmB;;IAEnB,SAAS;;IAET,mBAAmB;;IAEnB,SAAS;AACb;;;AAGA;;iEAEiE;;AAEjE;IACI,aAAa;;IAEb,sBAAsB;;IAEtB,uBAAuB;;IAEvB,QAAQ;;IAER,eAAe;;IAEf,SAAS;AACb;;;AAGA;IACI,SAAS;;IAET,cAAc;;IAEd,cAAc;;IAEd,gBAAgB;;IAEhB,gBAAgB;;IAEhB,yBAAyB;AAC7B;;;AAGA;IACI,SAAS;;IAET,eAAe;;IAEf,gBAAgB;;IAEhB,cAAc;AAClB;;;AAGA,SAAS;AACT;IACI,cAAc;AAClB;;;AAGA,YAAY;AACZ;IACI,cAAc;AAClB;;;AAGA;;iEAEiE;;AAEjE;IACI,UAAU;;IAEV,YAAY;;IAEZ,aAAa;;IAEb,SAAS;;IAET,mBAAmB;AACvB;;;AAGA;;iEAEiE;;AAEjE;IACI,WAAW;;IAEX,WAAW;;IAEX,SAAS;;IAET,gBAAgB;;IAEhB,kBAAkB;;IAElB,mBAAmB;AACvB;;;AAGA;IACI,YAAY;;IAEZ,SAAS;;IAET,kBAAkB;;IAElB,mBAAmB;AACvB;;;AAGA;;iEAEiE;;AAEjE;IACI,SAAS;;IAET,aAAa;;IAEb,kBAAkB;AACtB;;;AAGA;;iEAEiE;;AAEjE;IACI,aAAa;;IAEb,mBAAmB;;IAEnB,8BAA8B;;IAE9B,SAAS;;IAET,aAAa;;IAEb,kBAAkB;;IAElB,UAAU;AACd;;;AAGA;IACI,SAAS;;IAET,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;;IAEhB,gBAAgB;AACpB;;;AAGA,0CAA0C;AAC1C;IACI,SAAS;;IAET,gBAAgB;;IAEhB,cAAc;AAClB;;;AAGA;;iEAEiE;;AAEjE;IACI,mBAAmB;;IAEnB,SAAS;AACb;;;AAGA;;iEAEiE;;AAEjE;IACI,mBAAmB;AACvB;;;AAGA;;iEAEiE;;AAEjE;IACI,aAAa;;IAEb,mBAAmB;AACvB;;;AAGA;;iEAEiE;;AAEjE;;IAEI;QACI,0BAA0B;;QAE1B,QAAQ;IACZ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,SAAS;IACb;AACJ;;;AAGA;;iEAEiE;;AAEjE;;IAEI;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;AACJ;;AAEA;;;iEAGiE;;AAEjE,yCAAyC;AACzC;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;iDACiD;AACjD;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;;IAE1B,4BAA4B;IAC5B,6BAA6B;;IAE7B,6BAA6B;AACjC;;AAEA,iDAAiD;AACjD;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,2BAA2B;;IAE3B,4BAA4B;IAC5B,6BAA6B;;IAE7B,6BAA6B;AACjC;;AAEA,8BAA8B;AAC9B;IACI,mBAAmB;;IAEnB,6BAA6B;IAC7B,iCAAiC;;IAEjC,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,sBAAsB;AACtB;;;IAGI,0BAA0B;;IAE1B,4BAA4B;IAC5B,6BAA6B;;IAE7B,6BAA6B;AACjC;;;AAGA;;iEAEiE;;AAEjE;IACI,0BAA0B;IAC1B,sBAAsB;AAC1B;;;AAGA;;iEAEiE;;AAEjE;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,iCAAiC;AACrC;;;AAGA;;iEAEiE;;AAEjE;IACI,WAAW;IACX,0BAA0B;IAC1B,sBAAsB;AAC1B;;;AAGA;;iEAEiE;;AAEjE;;IAEI;QACI,0BAA0B;QAC1B,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;QAC1B,sBAAsB;IAC1B;AACJ;;AAEA;;iEAEiE;;AAEjE;IACI,mBAAmB;;IAEnB,gBAAgB;;IAEhB,wBAAwB;;IAExB,kBAAkB;;IAElB,aAAa;;IAEb,mBAAmB;;IAEnB,sBAAsB;AAC1B;;;AAGA,yBAAyB;AACzB;IACI,SAAS;;IAET,cAAc;;IAEd,0BAA0B;;IAE1B,2BAA2B;;IAE3B,gBAAgB;;IAEhB,iBAAiB;;IAEjB,mBAAmB;AACvB;;;AAGA;;iEAEiE;;AAEjE;IACI,wBAAwB;;IAExB,8BAA8B;;IAE9B,qBAAqB;;IAErB,aAAa;;IAEb,mBAAmB;;IAEnB,QAAQ;AACZ;;;AAGA,uBAAuB;AACvB;IACI,yBAAyB;;IAEzB,0BAA0B;;IAE1B,2BAA2B;;IAE3B,iBAAiB;;IAEjB,oBAAoB;AACxB;;;AAGA,qCAAqC;AACrC;IACI,eAAe;;IAEf,cAAc;;IAEd,0BAA0B;;IAE1B,gBAAgB;;IAEhB,gBAAgB;AACpB;;;AAGA,uCAAuC;AACvC;IACI,cAAc;;IAEd,0BAA0B;;IAE1B,gBAAgB;AACpB;;;AAGA;;iEAEiE;;AAEjE;IACI,yBAAyB;;IAEzB,0BAA0B;;IAE1B,2BAA2B;;IAE3B,iBAAiB;;IAEjB,oBAAoB;AACxB;;;AAGA,mCAAmC;AACnC;IACI,yBAAyB;;IAEzB,0BAA0B;;IAE1B,2BAA2B;;IAE3B,sBAAsB;;IAEtB,yBAAyB;;IAEzB,kBAAkB;AACtB;;;AAGA;;iEAEiE;;AAEjE;IACI,cAAc;;IAEd,0BAA0B;;IAE1B,2BAA2B;AAC/B;;AAEA;IACI,cAAc;;IAEd,0BAA0B;;IAE1B,2BAA2B;;IAE3B,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA;;iEAEiE;;AAEjE;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA;;iEAEiE;;AAEjE;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;;IAE1B,gBAAgB;AACpB;;;AAGA,4BAA4B;AAC5B;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA,SAAS;AACT;IACI,0BAA0B;;IAE1B,2BAA2B;;IAE3B,6BAA6B;;IAE7B,iCAAiC;AACrC;;;AAGA,YAAY;AACZ;IACI,0BAA0B;;IAE1B,2BAA2B;;IAE3B,6BAA6B;;IAE7B,iCAAiC;AACrC;;;AAGA,cAAc;AACd;IACI,0BAA0B;;IAE1B,2BAA2B;;IAE3B,6BAA6B;AACjC;;;AAGA,gBAAgB;AAChB;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA;;iEAEiE;;AAEjE;;IAEI;QACI,gBAAgB;;QAEhB,wBAAwB;;QAExB,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;;QAE1B,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,0BAA0B;IAC9B;AACJ;;AAEA;;;;;;;;iEAQiE;;;AAGjE;;iEAEiE;;AAEjE;IACI,aAAa;IACb,mBAAmB;;IAEnB,gBAAgB;;IAEhB,wBAAwB;;IAExB,eAAe;;IAEf,mBAAmB;;IAEnB,gCAAgC;;IAEhC,sBAAsB;AAC1B;;;AAGA,eAAe;AACf;IACI,oBAAoB;;IAEpB,yBAAyB;;IAEzB,0BAA0B;;IAE1B,2BAA2B;;IAE3B,4BAA4B;;IAE5B,4BAA4B;;IAE5B,mBAAmB;AACvB;;;AAGA;sDACsD;AACtD;IACI,aAAa;AACjB;;;AAGA,wDAAwD;AACxD;IACI,aAAa;AACjB;;;AAGA;;iEAEiE;;AAEjE;IACI,aAAa;;IAEb,uBAAuB;;IAEvB,8BAA8B;;IAE9B,SAAS;;IAET,wBAAwB;;IAExB,8BAA8B;;IAE9B,qBAAqB;AACzB;;;AAGA;IACI,oBAAoB;;IAEpB,yBAAyB;;IAEzB,0BAA0B;;IAE1B,2BAA2B;;IAE3B,kCAAkC;;IAElC,2BAA2B;AAC/B;;;AAGA,mBAAmB;AACnB;IACI,0BAA0B;;IAE1B,yBAAyB;;IAEzB,0BAA0B;;IAE1B,2BAA2B;;IAE3B,2BAA2B;AAC/B;;;AAGA;IACI,yBAAyB;;IAEzB,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA,sBAAsB;AACtB;IACI,yBAAyB;;IAEzB,0BAA0B;;IAE1B,2BAA2B;;IAE3B,iBAAiB;AACrB;;;AAGA;;;iEAGiE;;AAEjE;IACI,wBAAwB;AAC5B;;;AAGA,kDAAkD;AAClD;IACI,aAAa;;IAEb,mBAAmB;;IAEnB,uBAAuB;;IAEvB,iBAAiB;;IAEjB,gBAAgB;;IAEhB,iBAAiB;;IAEjB,kBAAkB;AACtB;;;AAGA,oBAAoB;AACpB;IACI,cAAc;;IAEd,gBAAgB;;IAEhB,gBAAgB;;IAEhB,yBAAyB;;IAEzB,0BAA0B;;IAE1B,2BAA2B;;IAE3B,4BAA4B;;IAE5B,kBAAkB;;IAElB,uBAAuB;;IAEvB,mBAAmB;AACvB;;;AAGA;;;iEAGiE;;AAEjE;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA;;iEAEiE;;AAEjE;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA;;iEAEiE;;AAEjE;IACI,0BAA0B;AAC9B;;;AAGA;;IAEI,0BAA0B;;IAE1B,gBAAgB;;IAEhB,iCAAiC;AACrC;;;AAGA,WAAW;AACX;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA,8BAA8B;AAC9B;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA,kBAAkB;AAClB;IACI,0BAA0B;;IAE1B,2BAA2B;;IAE3B,6BAA6B;AACjC;;;AAGA,gBAAgB;AAChB;IACI,0BAA0B;;IAE1B,2BAA2B;;IAE3B,6BAA6B;AACjC;;;AAGA,mBAAmB;AACnB;IACI,0BAA0B;;IAE1B,2BAA2B;;IAE3B,6BAA6B;AACjC;;;AAGA,cAAc;AACd;IACI,0BAA0B;;IAE1B,2BAA2B;;IAE3B,6BAA6B;;IAE7B,iCAAiC;AACrC;;;AAGA,SAAS;AACT;IACI,0BAA0B;;IAE1B,2BAA2B;;IAE3B,6BAA6B;;IAE7B,iCAAiC;AACrC;;;AAGA,YAAY;AACZ;IACI,0BAA0B;;IAE1B,2BAA2B;;IAE3B,6BAA6B;;IAE7B,iCAAiC;AACrC;;;AAGA,UAAU;AACV;IACI,0BAA0B;;IAE1B,2BAA2B;;IAE3B,6BAA6B;;IAE7B,iCAAiC;AACrC;;;AAGA;;iEAEiE;;AAEjE;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA,kBAAkB;AAClB;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA;;;;;;iEAMiE;;AAEjE;IACI,uBAAuB;;IAEvB,6BAA6B;AACjC;;;AAGA;IACI,kBAAkB;;IAElB,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;AACpB;;;AAGA;;iEAEiE;;AAEjE;IACI,0BAA0B;;IAE1B,2BAA2B;;IAE3B,6BAA6B;AACjC;;;AAGA;;iEAEiE;;AAEjE;;IAEI,gBAAgB;;IAEhB,2BAA2B;;IAE3B,8BAA8B;AAClC;;;AAGA;IACI,2BAA2B;AAC/B;;;AAGA;;iEAEiE;;AAEjE;IACI,2DAA2D;;IAE3D,oBAAoB;;IAEpB,oBAAoB;AACxB;;;AAGA;IACI,6BAA6B;;IAE7B,6BAA6B;;IAE7B,2BAA2B;AAC/B;;;AAGA;;iEAEiE;;AAEjE;IACI,iBAAiB;;IAEjB,2BAA2B;AAC/B;;;AAGA;IACI,2BAA2B;;IAE3B,6BAA6B;;IAE7B,2BAA2B;;IAE3B,8BAA8B;;IAE9B,yBAAyB;;IAEzB,2BAA2B;AAC/B;;;AAGA;IACI,8BAA8B;AAClC;;;AAGA;;iEAEiE;;AAEjE;IACI,wBAAwB;AAC5B;;;AAGA;;iEAEiE;;AAEjE;IACI,8BAA8B;AAClC;;;AAGA;IACI,6BAA6B;AACjC;;;AAGA;;iEAEiE;;AAEjE;IACI,6BAA6B;AACjC;;;AAGA;IACI,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;AAGA;;iEAEiE;;AAEjE;;IAEI;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;;AAGA;;iEAEiE;;AAEjE;;IAEI;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;;AAGA;;iEAEiE;;AAEjE;;IAEI;QACI,gBAAgB;;QAEhB,wBAAwB;;QAExB,eAAe;;QAEf,wBAAwB;IAC5B;;;IAGA;QACI,0BAA0B;;QAE1B,4BAA4B;;QAE5B,mBAAmB;IACvB;;;IAGA;QACI,0BAA0B;IAC9B;;;IAGA;QACI,0BAA0B;IAC9B;;;IAGA;QACI,0BAA0B;IAC9B;;;IAGA;QACI,gBAAgB;;QAEhB,0BAA0B;IAC9B;;;IAGA;;QAEI,0BAA0B;IAC9B;;;IAGA;;QAEI,0BAA0B;IAC9B;;;IAGA;QACI,qCAAqC;IACzC;AACJ;;;AAGA;;iEAEiE;;AAEjE;;IAEI;QACI,0BAA0B;IAC9B;;;IAGA;QACI,0BAA0B;IAC9B;;;IAGA;QACI,gBAAgB;;QAEhB,0BAA0B;IAC9B;AACJ;;AAEA;;iEAEiE;;AAEjE;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;;IAEhB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,eAAe;;IAEf,yBAAyB;IACzB,kBAAkB;;IAElB,mBAAmB;IACnB,cAAc;;IAEd,eAAe;IACf,gBAAgB;;IAEhB,eAAe;;IAEf,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;iEAEiE;;AAEjE;IACI,kBAAkB;;IAElB,qBAAqB;IACrB,OAAO;IACP,QAAQ;;IAER,WAAW;IACX,gBAAgB;;IAEhB,mBAAmB;;IAEnB,yBAAyB;IACzB,kBAAkB;;IAElB;0CACsC;;IAEtC,eAAe;;IAEf,gBAAgB;AACpB;;AAEA;;iEAEiE;;AAEjE;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,iBAAiB;;IAEjB,mBAAmB;;IAEnB,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,uBAAuB;;IAEvB,cAAc;;IAEd,eAAe;IACf,gBAAgB;;IAEhB,gBAAgB;;IAEhB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;iEAEiE;;AAEjE;IACI,WAAW;;IAEX,iBAAiB;;IAEjB,gBAAgB;;IAEhB,cAAc;;IAEd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;;IAEnB,WAAW;;IAEX,SAAS;;IAET,kBAAkB;;IAElB,mBAAmB;;IAEnB,cAAc;;IAEd,eAAe;IACf,gBAAgB;;IAEhB,eAAe;;IAEf,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,SAAS;;IAET,cAAc;;IAEd,eAAe;;IAEf,qBAAqB;AACzB;;AAEA;IACI,cAAc;;IAEd,cAAc;;IAEd,eAAe;IACf,gBAAgB;;IAEhB,UAAU;IACV,mBAAmB;AACvB;;AAEA;;iEAEiE;;AAEjE;IACI,aAAa;;IAEb,kBAAkB;;IAElB,cAAc;;IAEd,eAAe;AACnB;;AAEA;;iEAEiE;;AAEjE;IACI,iBAAiB;;IAEjB,6BAA6B;;IAE7B,mBAAmB;;IAEnB,cAAc;;IAEd,eAAe;IACf,gBAAgB;AACpB;;AAEA;;iEAEiE;;AAEjE;IACI,kBAAkB;IAClB,WAAW;;IAEX,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;;IAEX,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;;IAElB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd","sourcesContent":["/* ============================================================\r\n   COURSE PAYMENT ANALYTICS\r\n   ============================================================ */\r\n\r\n.cpa-app {\r\n  --cpa-bg: #f5f8fb;\r\n  --cpa-surface: #ffffff;\r\n  --cpa-border: #d7d7d7;\r\n  --cpa-border-dark: #c8d0d8;\r\n  --cpa-text: #17202a;\r\n  --cpa-muted: #5f6b76;\r\n  --cpa-soft: #edf6fc;\r\n  --cpa-primary: #347cb5;\r\n  --cpa-primary-dark: #173f63;\r\n  --cpa-primary-soft: #dcecf8;\r\n  --cpa-paid: #347cb5;\r\n  --cpa-pending: #6ead4f;\r\n  --cpa-pending-soft: #e8f3d8;\r\n  --cpa-shadow: 0 8px 30px rgba(23, 33, 43, 0.06);\r\n\r\n  width: 100%;\r\n  min-height: 100%;\r\n  padding: 28px;\r\n  background: var(--cpa-bg);\r\n  color: var(--cpa-text);\r\n  font-family:\r\n    Inter,\r\n    -apple-system,\r\n    BlinkMacSystemFont,\r\n    \"Segoe UI\",\r\n    sans-serif;\r\n}\r\n\r\n/* ============================================================\r\n   HEADER\r\n   ============================================================ */\r\n\r\n.cpa-masthead {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 24px;\r\n  margin-bottom: 22px;\r\n}\r\n\r\n.cpa-brand-block {\r\n  min-width: 0;\r\n}\r\n\r\n.cpa-eyebrow {\r\n  margin-bottom: 7px;\r\n  color: var(--cpa-primary);\r\n  font-size: 11px;\r\n  font-weight: 800;\r\n  letter-spacing: 0.14em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.cpa-masthead h1 {\r\n  margin: 0;\r\n  color: var(--cpa-text);\r\n  font-size: clamp(25px, 3vw, 34px);\r\n  font-weight: 750;\r\n  letter-spacing: -0.035em;\r\n  line-height: 1.1;\r\n}\r\n\r\n.cpa-sub {\r\n  margin: 8px 0 0;\r\n  color: var(--cpa-muted);\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.cpa-course-context {\r\n  min-width: 260px;\r\n  max-width: 390px;\r\n  padding: 16px 18px;\r\n  border: 1px solid var(--cpa-border);\r\n  border-radius: 12px;\r\n  background: var(--cpa-surface);\r\n  box-shadow: 0 4px 18px rgba(23, 33, 43, 0.04);\r\n}\r\n\r\n.cpa-context-label {\r\n  margin-bottom: 5px;\r\n  color: var(--cpa-muted);\r\n  font-size: 10px;\r\n  font-weight: 800;\r\n  letter-spacing: 0.1em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.cpa-cname {\r\n  overflow: hidden;\r\n  color: var(--cpa-text);\r\n  font-size: 15px;\r\n  font-weight: 750;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.cpa-cmeta {\r\n  margin-top: 5px;\r\n  color: var(--cpa-primary);\r\n  font-size: 12px;\r\n  font-weight: 650;\r\n}\r\n\r\n.cpa-cid {\r\n  margin-top: 7px;\r\n  overflow: hidden;\r\n  color: #9aa2aa;\r\n  font-family:\r\n    \"SFMono-Regular\",\r\n    Consolas,\r\n    monospace;\r\n  font-size: 9px;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ============================================================\r\n   CONTROL PANEL\r\n   ============================================================ */\r\n\r\n.cpa-panel {\r\n  position: relative;\r\n  margin-bottom: 18px;\r\n  padding: 20px;\r\n  border: 1px solid var(--cpa-border);\r\n  border-radius: 14px;\r\n  background: var(--cpa-surface);\r\n  box-shadow: var(--cpa-shadow);\r\n}\r\n\r\n.cpa-panel-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n  margin-bottom: 17px;\r\n}\r\n\r\n.cpa-panel-title {\r\n  color: var(--cpa-text);\r\n  font-size: 14px;\r\n  font-weight: 750;\r\n}\r\n\r\n.cpa-panel-subtitle {\r\n  margin-top: 3px;\r\n  color: var(--cpa-muted);\r\n  font-size: 12px;\r\n}\r\n\r\n.cpa-selection-count {\r\n  flex-shrink: 0;\r\n  padding: 6px 10px;\r\n  border: 1px solid #cce7e3;\r\n  border-radius: 7px;\r\n  background: var(--cpa-primary-soft);\r\n  color: var(--cpa-primary-dark);\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n}\r\n\r\n.cpa-panel-grid {\r\n  display: grid;\r\n  grid-template-columns:\r\n    minmax(240px, 1.15fr)\r\n    minmax(240px, 1.15fr)\r\n    auto;\r\n  align-items: end;\r\n  gap: 14px;\r\n}\r\n\r\n.cpa-field {\r\n  min-width: 0;\r\n}\r\n\r\n.cpa-field label {\r\n  display: block;\r\n  margin-bottom: 7px;\r\n  color: #3d4852;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n}\r\n\r\n.cpa-control {\r\n  width: 100%;\r\n  min-height: 44px;\r\n  padding: 0 38px 0 13px;\r\n  border: 1px solid var(--cpa-border-dark);\r\n  border-radius: 9px;\r\n  outline: none;\r\n  background: #fff;\r\n  color: var(--cpa-text);\r\n  font-size: 13px;\r\n  font-weight: 550;\r\n  cursor: pointer;\r\n  transition:\r\n    border-color 0.16s ease,\r\n    box-shadow 0.16s ease;\r\n}\r\n\r\n.cpa-control:focus {\r\n  border-color: var(--cpa-primary);\r\n  box-shadow: 0 0 0 3px rgba(8, 127, 115, 0.1);\r\n}\r\n\r\n.cpa-control:disabled {\r\n  background: #f1f3f5;\r\n  color: #9aa2aa;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.cpa-field-hint {\r\n  margin-top: 6px;\r\n  color: var(--cpa-muted);\r\n  font-size: 10px;\r\n}\r\n\r\n/* ============================================================\r\n   TERM SELECT\r\n   ============================================================ */\r\n\r\n.cpa-term-select {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.cpa-term-trigger {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  min-height: 44px;\r\n  padding: 0 13px;\r\n  border: 1px solid var(--cpa-border-dark);\r\n  border-radius: 9px;\r\n  outline: none;\r\n  background: #fff;\r\n  color: var(--cpa-text);\r\n  font-size: 13px;\r\n  font-weight: 550;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition:\r\n    border-color 0.16s ease,\r\n    box-shadow 0.16s ease;\r\n}\r\n\r\n.cpa-term-trigger:hover:not(:disabled) {\r\n  border-color: #aeb8c1;\r\n}\r\n\r\n.cpa-term-trigger:focus {\r\n  border-color: var(--cpa-primary);\r\n  box-shadow: 0 0 0 3px rgba(8, 127, 115, 0.1);\r\n}\r\n\r\n.cpa-term-trigger:disabled {\r\n  background: #f1f3f5;\r\n  color: #9aa2aa;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.cpa-term-trigger-text {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.cpa-chev {\r\n  flex-shrink: 0;\r\n  margin-left: 10px;\r\n  color: #7e8993;\r\n  font-size: 15px;\r\n}\r\n\r\n.cpa-term-dropdown {\r\n  position: absolute;\r\n  z-index: 100;\r\n  top: calc(100% + 7px);\r\n  left: 0;\r\n  width: 100%;\r\n  min-width: 245px;\r\n  overflow: hidden;\r\n  border: 1px solid var(--cpa-border);\r\n  border-radius: 11px;\r\n  background: #fff;\r\n  box-shadow:\r\n    0 16px 42px rgba(23, 33, 43, 0.14),\r\n    0 3px 10px rgba(23, 33, 43, 0.06);\r\n}\r\n\r\n.cpa-term-dropdown-actions {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 9px 11px;\r\n  border-bottom: 1px solid var(--cpa-border);\r\n  background: #fafbfc;\r\n}\r\n\r\n.cpa-term-dropdown-actions button {\r\n  padding: 4px 6px;\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--cpa-primary);\r\n  font-size: 11px;\r\n  font-weight: 750;\r\n  cursor: pointer;\r\n}\r\n\r\n.cpa-term-dropdown-actions button:disabled {\r\n  color: #adb4bb;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.cpa-term-options {\r\n  max-height: 230px;\r\n  overflow-y: auto;\r\n  padding: 5px;\r\n}\r\n\r\n.cpa-term-option {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  min-height: 37px;\r\n  padding: 0 8px;\r\n  border-radius: 7px;\r\n  color: #35414c;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.cpa-term-option:hover {\r\n  background: #f4f7f7;\r\n}\r\n\r\n.cpa-term-option input {\r\n  width: 15px;\r\n  height: 15px;\r\n  margin: 0;\r\n  accent-color: var(--cpa-primary);\r\n}\r\n\r\n.cpa-term-empty {\r\n  padding: 18px 10px;\r\n  color: var(--cpa-muted);\r\n  font-size: 11px;\r\n  text-align: center;\r\n}\r\n\r\n.cpa-term-dropdown-footer {\r\n  padding: 8px 11px;\r\n  border-top: 1px solid var(--cpa-border);\r\n  color: var(--cpa-muted);\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* ============================================================\r\n   ACTIONS\r\n   ============================================================ */\r\n\r\n.cpa-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.cpa-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 7px;\r\n  min-height: 42px;\r\n  padding: 0 14px;\r\n  border-radius: 8px;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n  transition:\r\n    transform 0.15s ease,\r\n    box-shadow 0.15s ease,\r\n    background 0.15s ease,\r\n    border-color 0.15s ease;\r\n}\r\n\r\n.cpa-btn:hover:not(:disabled) {\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.cpa-btn:disabled {\r\n  opacity: 0.48;\r\n  cursor: not-allowed;\r\n  transform: none;\r\n}\r\n\r\n.cpa-btn-primary {\r\n  border: 1px solid var(--cpa-primary);\r\n  background: var(--cpa-primary);\r\n  color: #fff;\r\n  box-shadow: 0 4px 12px rgba(8, 127, 115, 0.17);\r\n}\r\n\r\n.cpa-btn-primary:hover:not(:disabled) {\r\n  background: var(--cpa-primary-dark);\r\n}\r\n\r\n.cpa-btn-secondary {\r\n  border: 1px solid var(--cpa-border-dark);\r\n  background: #fff;\r\n  color: #35414c;\r\n}\r\n\r\n.cpa-btn-secondary:hover:not(:disabled) {\r\n  border-color: #b4bec6;\r\n  background: #f9fafb;\r\n}\r\n\r\n.cpa-btn-ghost {\r\n  border: 1px solid #cce2df;\r\n  background: var(--cpa-primary-soft);\r\n  color: var(--cpa-primary-dark);\r\n}\r\n\r\n.cpa-btn-ghost:hover:not(:disabled) {\r\n  background: #def0ed;\r\n}\r\n\r\n.cpa-refresh-icon {\r\n  font-size: 17px;\r\n  line-height: 1;\r\n}\r\n\r\n.cpa-spinner {\r\n  width: 14px;\r\n  height: 14px;\r\n  border: 2px solid rgba(255, 255, 255, 0.4);\r\n  border-top-color: #fff;\r\n  border-radius: 50%;\r\n  animation: cpa-spin 0.7s linear infinite;\r\n}\r\n\r\n@keyframes cpa-spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* ============================================================\r\n   VALIDATION / ERROR\r\n   ============================================================ */\r\n\r\n.cpa-validation-msg,\r\n.cpa-banner {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  margin-top: 13px;\r\n  padding: 10px 12px;\r\n  border-radius: 8px;\r\n  font-size: 12px;\r\n  font-weight: 550;\r\n}\r\n\r\n.cpa-validation-msg {\r\n  border: 1px solid #f0d9ad;\r\n  background: #fff8ec;\r\n  color: #80500d;\r\n}\r\n\r\n.cpa-banner {\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.cpa-banner-error {\r\n  border: 1px solid #f0caca;\r\n  background: #fff5f5;\r\n  color: #963838;\r\n}\r\n\r\n.cpa-banner-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 18px;\r\n  height: 18px;\r\n  flex: 0 0 18px;\r\n  border-radius: 50%;\r\n  background: currentColor;\r\n  color: #fff;\r\n  font-size: 10px;\r\n  font-weight: 800;\r\n}\r\n\r\n/* ============================================================\r\n   DASHBOARD CONTEXT\r\n   ============================================================ */\r\n\r\n.cpa-dashboard-context {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.cpa-dashboard-course {\r\n  color: var(--cpa-text);\r\n  font-size: 19px;\r\n  font-weight: 760;\r\n  letter-spacing: -0.02em;\r\n}\r\n\r\n.cpa-dashboard-term-line {\r\n  margin-top: 4px;\r\n  color: var(--cpa-muted);\r\n  font-size: 11px;\r\n}\r\n\r\n.cpa-dashboard-term-line span {\r\n  margin-left: 4px;\r\n  color: var(--cpa-primary);\r\n  font-weight: 700;\r\n}\r\n\r\n.cpa-dashboard-meta {\r\n  color: #8a949d;\r\n  font-size: 10px;\r\n  text-align: right;\r\n}\r\n\r\n/* ============================================================\r\n   SUMMARY CARDS\r\n   ============================================================ */\r\n\r\n.cpa-summary-cards {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  gap: 13px;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.cpa-summary-card {\r\n  display: flex;\r\n  gap: 13px;\r\n  min-height: 132px;\r\n  padding: 17px;\r\n  border: 1px solid var(--cpa-border);\r\n  border-radius: 12px;\r\n  background: #fff;\r\n  box-shadow: 0 4px 18px rgba(23, 33, 43, 0.045);\r\n}\r\n\r\n.cpa-summary-card.cpa-primary-metric {\r\n  border-color: #c7e4df;\r\n  box-shadow:\r\n    0 5px 20px rgba(8, 127, 115, 0.09);\r\n}\r\n\r\n.cpa-sc-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  flex: 0 0 36px;\r\n  border-radius: 9px;\r\n  font-size: 11px;\r\n  font-weight: 850;\r\n}\r\n\r\n.cpa-icon-neutral {\r\n  background: #eef1f3;\r\n  color: #5e6972;\r\n}\r\n\r\n.cpa-icon-paid {\r\n  background: var(--cpa-primary-soft);\r\n  color: var(--cpa-primary);\r\n  font-size: 17px;\r\n}\r\n\r\n.cpa-icon-pending {\r\n  background: var(--cpa-pending-soft);\r\n  color: var(--cpa-pending);\r\n  font-size: 17px;\r\n}\r\n\r\n.cpa-icon-pct {\r\n  background: #eef1f3;\r\n  color: #46535e;\r\n  font-size: 14px;\r\n}\r\n\r\n.cpa-sc-content {\r\n  min-width: 0;\r\n}\r\n\r\n.cpa-sc-label {\r\n  color: #56616b;\r\n  font-size: 11px;\r\n  font-weight: 750;\r\n}\r\n\r\n.cpa-sc-value {\r\n  margin-top: 7px;\r\n  color: var(--cpa-text);\r\n  font-size: 25px;\r\n  font-weight: 800;\r\n  letter-spacing: -0.03em;\r\n  line-height: 1;\r\n}\r\n\r\n.cpa-paid .cpa-sc-value {\r\n  color: var(--cpa-primary-dark);\r\n}\r\n\r\n.cpa-pending .cpa-sc-value {\r\n  color: #9a5b10;\r\n}\r\n\r\n.cpa-sc-desc {\r\n  margin-top: 8px;\r\n  color: #8a949d;\r\n  font-size: 10px;\r\n  line-height: 1.4;\r\n}\r\n\r\n/* ============================================================\r\n   PROGRESS\r\n   ============================================================ */\r\n\r\n.cpa-progress-card {\r\n  margin-bottom: 21px;\r\n  padding: 20px;\r\n  border: 1px solid var(--cpa-border);\r\n  border-radius: 12px;\r\n  background: #fff;\r\n  box-shadow: 0 4px 18px rgba(23, 33, 43, 0.04);\r\n}\r\n\r\n.cpa-progress-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n}\r\n\r\n.cpa-section-kicker {\r\n  margin-bottom: 3px;\r\n  color: var(--cpa-primary);\r\n  font-size: 9px;\r\n  font-weight: 850;\r\n  letter-spacing: 0.12em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.cpa-pc-title {\r\n  color: var(--cpa-text);\r\n  font-size: 15px;\r\n  font-weight: 760;\r\n}\r\n\r\n.cpa-pc-pct {\r\n  color: var(--cpa-primary-dark);\r\n  font-size: 22px;\r\n  font-weight: 800;\r\n}\r\n\r\n.cpa-pc-stat {\r\n  margin-top: 12px;\r\n  color: #59656f;\r\n  font-size: 12px;\r\n}\r\n\r\n.cpa-progress-track {\r\n  width: 100%;\r\n  height: 9px;\r\n  margin-top: 14px;\r\n  overflow: hidden;\r\n  border-radius: 99px;\r\n  background: #e9eeef;\r\n}\r\n\r\n.cpa-progress-fill {\r\n  height: 100%;\r\n  border-radius: inherit;\r\n  background: var(--cpa-primary);\r\n  transition: width 0.5s ease;\r\n}\r\n\r\n.cpa-progress-note {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 7px;\r\n  margin-top: 11px;\r\n  color: #7b858e;\r\n  font-size: 10px;\r\n  line-height: 1.45;\r\n}\r\n\r\n.cpa-info-dot {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 16px;\r\n  height: 16px;\r\n  flex: 0 0 16px;\r\n  border: 1px solid #c8d1d7;\r\n  border-radius: 50%;\r\n  color: #7d8891;\r\n  font-size: 9px;\r\n  font-weight: 800;\r\n}\r\n\r\n/* ============================================================\r\n   SECTIONS\r\n   ============================================================ */\r\n\r\n.cpa-section {\r\n  margin-bottom: 21px;\r\n}\r\n\r\n.cpa-section-header {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n  margin-bottom: 11px;\r\n}\r\n\r\n.cpa-section-title {\r\n  color: var(--cpa-text);\r\n  font-size: 15px;\r\n  font-weight: 760;\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.cpa-tag {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 5px 8px;\r\n  border-radius: 6px;\r\n  font-size: 9px;\r\n  font-weight: 700;\r\n}\r\n\r\n.cpa-tag-muted {\r\n  background: #edf1f3;\r\n  color: #68737d;\r\n}\r\n\r\n/* ============================================================\r\n   TERM CARDS\r\n   ============================================================ */\r\n\r\n.cpa-term-cards {\r\n  display: grid;\r\n  grid-template-columns: repeat(\r\n    auto-fit,\r\n    minmax(210px, 1fr)\r\n  );\r\n  gap: 11px;\r\n}\r\n\r\n.cpa-term-card {\r\n  padding: 14px;\r\n  border: 1px solid var(--cpa-border);\r\n  border-radius: 10px;\r\n  background: #fff;\r\n  box-shadow: 0 3px 14px rgba(23, 33, 43, 0.035);\r\n}\r\n\r\n.cpa-tc-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  padding-bottom: 10px;\r\n  border-bottom: 1px solid #edf0f2;\r\n}\r\n\r\n.cpa-tc-name {\r\n  color: var(--cpa-text);\r\n  font-size: 12px;\r\n  font-weight: 800;\r\n}\r\n\r\n.cpa-tc-percent {\r\n  color: var(--cpa-primary);\r\n  font-size: 12px;\r\n  font-weight: 800;\r\n}\r\n\r\n.cpa-tc-main {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 17px;\r\n  padding: 13px 0 10px;\r\n}\r\n\r\n.cpa-tc-stat {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n}\r\n\r\n.cpa-tc-stat-label {\r\n  color: #8a949d;\r\n  font-size: 9px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.cpa-tc-stat strong {\r\n  font-size: 18px;\r\n  font-weight: 800;\r\n}\r\n\r\n.cpa-tc-paid {\r\n  color: var(--cpa-primary-dark);\r\n}\r\n\r\n.cpa-tc-pending {\r\n  color: #9a5b10;\r\n}\r\n\r\n.cpa-tc-divider {\r\n  width: 1px;\r\n  height: 30px;\r\n  background: #e7eaec;\r\n}\r\n\r\n.cpa-tc-progress-track {\r\n  height: 5px;\r\n  overflow: hidden;\r\n  border-radius: 99px;\r\n  background: #edf0f1;\r\n}\r\n\r\n.cpa-tc-progress-fill {\r\n  height: 100%;\r\n  border-radius: inherit;\r\n  background: var(--cpa-primary);\r\n}\r\n\r\n.cpa-term-cards-empty {\r\n  padding: 18px;\r\n  border: 1px dashed var(--cpa-border-dark);\r\n  border-radius: 9px;\r\n  color: var(--cpa-muted);\r\n  font-size: 11px;\r\n  text-align: center;\r\n}\r\n\r\n/* ============================================================\r\n   TABLE CARD\r\n   ============================================================ */\r\n\r\n.cpa-table-card {\r\n  overflow: hidden;\r\n  margin-bottom: 17px;\r\n  border: 1px solid var(--cpa-border);\r\n  border-radius: 13px;\r\n  background: #fff;\r\n  box-shadow: 0 4px 18px rgba(23, 33, 43, 0.04);\r\n}\r\n\r\n.cpa-table-heading {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n  padding: 17px 18px;\r\n  border-bottom: 1px solid var(--cpa-border);\r\n}\r\n\r\n.cpa-table-caption {\r\n  color: #8a949d;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* ============================================================\r\n   TABLE SCROLL\r\n   ============================================================ */\r\n\r\n.cpa-table-scroll {\r\n  width: 100%;\r\n  overflow-x: auto;\r\n  overflow-y: visible;\r\n  scrollbar-width: thin;\r\n}\r\n\r\n.cpa-table-scroll::-webkit-scrollbar {\r\n  height: 8px;\r\n}\r\n\r\n.cpa-table-scroll::-webkit-scrollbar-track {\r\n  background: #f1f3f4;\r\n}\r\n\r\n.cpa-table-scroll::-webkit-scrollbar-thumb {\r\n  border-radius: 99px;\r\n  background: #c4ccd1;\r\n}\r\n\r\n/* ============================================================\r\n   TABLE\r\n   ============================================================ */\r\n\r\n.cpa-analytics-table {\r\n  width: max-content;\r\n  min-width: 100%;\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n  color: #34404a;\r\n  font-size: 11px;\r\n}\r\n\r\n.cpa-analytics-table th,\r\n.cpa-analytics-table td {\r\n  min-width: 82px;\r\n  padding: 11px 10px;\r\n  border-right: 1px solid #edf0f2;\r\n  border-bottom: 1px solid #edf0f2;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n}\r\n\r\n.cpa-analytics-table th:first-child,\r\n.cpa-analytics-table td:first-child {\r\n  min-width: 235px;\r\n  text-align: left;\r\n}\r\n\r\n.cpa-analytics-table th {\r\n  color: #52606b;\r\n  background: #f7f9fa;\r\n  font-size: 9px;\r\n  font-weight: 800;\r\n  letter-spacing: 0.02em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.cpa-analytics-table thead tr:first-child th {\r\n  height: 42px;\r\n}\r\n\r\n.cpa-analytics-table thead tr:last-child th {\r\n  height: 33px;\r\n  background: #fafbfb;\r\n  font-size: 8px;\r\n}\r\n\r\n.cpa-term-group-header {\r\n  color: var(--cpa-primary-dark) !important;\r\n  background: var(--cpa-primary-soft) !important;\r\n  border-bottom-color: #d2e9e6 !important;\r\n}\r\n\r\n.cpa-sub-header th {\r\n  color: #68747e !important;\r\n}\r\n\r\n/* ============================================================\r\n   STICKY COLUMNS\r\n   ============================================================ */\r\n\r\n.cpa-sticky-col {\r\n  position: sticky;\r\n  z-index: 3;\r\n  background: #fff;\r\n}\r\n\r\n.cpa-sticky-tech {\r\n  left: 0;\r\n}\r\n\r\n.cpa-sticky-reg {\r\n  left: 235px;\r\n}\r\n\r\n.cpa-sticky-paid {\r\n  left: 317px;\r\n}\r\n\r\n.cpa-sticky-pending {\r\n  left: 399px;\r\n}\r\n\r\n.cpa-analytics-table thead .cpa-sticky-col {\r\n  z-index: 8;\r\n  background: #f7f9fa;\r\n}\r\n\r\n.cpa-analytics-table tbody tr:hover td {\r\n  background: #fafcfc;\r\n}\r\n\r\n.cpa-analytics-table tbody tr:hover .cpa-sticky-col {\r\n  background: #fafcfc;\r\n}\r\n\r\n/* ============================================================\r\n   OVERALL ROW\r\n   ============================================================ */\r\n\r\n.cpa-overall-row td {\r\n  background: #f5faf9;\r\n  border-bottom-color: #dcebe8;\r\n  font-weight: 650;\r\n}\r\n\r\n.cpa-overall-row .cpa-sticky-col {\r\n  background: #f5faf9;\r\n}\r\n\r\n.cpa-overall-row:hover td {\r\n  background: #f1f8f7 !important;\r\n}\r\n\r\n.cpa-overall-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-weight: 800;\r\n}\r\n\r\n.cpa-overall-dot {\r\n  width: 7px;\r\n  height: 7px;\r\n  flex: 0 0 7px;\r\n  border-radius: 50%;\r\n  background: var(--cpa-primary);\r\n}\r\n\r\n.cpa-term-overall-cell {\r\n  background: #f2f8f7 !important;\r\n  font-weight: 750 !important;\r\n}\r\n\r\n/* ============================================================\r\n   TABLE CELLS\r\n   ============================================================ */\r\n\r\n.cpa-cell-paid {\r\n  color: var(--cpa-primary-dark);\r\n  font-weight: 650;\r\n}\r\n\r\n.cpa-cell-pending {\r\n  color: #a26216;\r\n  font-weight: 600;\r\n}\r\n\r\n.cpa-cell-pct {\r\n  color: #34404a;\r\n  font-weight: 700;\r\n}\r\n\r\n.cpa-cell-dim {\r\n  color: #a2abb2 !important;\r\n  font-weight: 500 !important;\r\n}\r\n\r\n.cpa-strong {\r\n  font-weight: 850 !important;\r\n}\r\n\r\n/* ============================================================\r\n   TECHNOLOGY CELL\r\n   ============================================================ */\r\n\r\n.cpa-tech-cell {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  min-height: 52px;\r\n}\r\n\r\n.cpa-tech-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 30px;\r\n  height: 30px;\r\n  flex: 0 0 30px;\r\n  overflow: hidden;\r\n  border: 1px solid #dce3e6;\r\n  border-radius: 8px;\r\n  background: #f1f4f5;\r\n  color: #56636e;\r\n  font-size: 11px;\r\n  font-weight: 850;\r\n}\r\n\r\n.cpa-tech-icon img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.cpa-tech-icon-fallback {\r\n  position: relative;\r\n}\r\n\r\n.cpa-tech-icon-fallback[data-initial] {\r\n  font-size: 0;\r\n}\r\n\r\n.cpa-tech-icon-fallback[data-initial]::after {\r\n  content: attr(data-initial);\r\n  font-size: 11px;\r\n}\r\n\r\n.cpa-tech-name {\r\n  display: block;\r\n  min-width: 0;\r\n  max-width: 190px;\r\n  overflow: hidden;\r\n  color: #29353e;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  line-height: 1.35;\r\n  text-overflow: ellipsis;\r\n  white-space: normal;\r\n}\r\n\r\n/* ============================================================\r\n   TECHNOLOGY PAYMENT\r\n   ============================================================ */\r\n\r\n.cpa-tech-payment {\r\n  min-width: 76px;\r\n}\r\n\r\n.cpa-mini-progress {\r\n  width: 100%;\r\n  height: 3px;\r\n  margin-top: 5px;\r\n  overflow: hidden;\r\n  border-radius: 99px;\r\n  background: #e9eeee;\r\n}\r\n\r\n.cpa-mini-progress div {\r\n  height: 100%;\r\n  border-radius: inherit;\r\n  background: var(--cpa-primary);\r\n}\r\n\r\n/* ============================================================\r\n   TABLE EMPTY / FOOTNOTE\r\n   ============================================================ */\r\n\r\n.cpa-table-empty {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  padding: 28px 20px;\r\n  color: var(--cpa-muted);\r\n  text-align: left;\r\n}\r\n\r\n.cpa-table-empty-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 34px;\r\n  height: 34px;\r\n  border-radius: 9px;\r\n  background: #f0f2f3;\r\n  color: #89939c;\r\n  font-weight: 800;\r\n}\r\n\r\n.cpa-table-empty strong {\r\n  color: #4e5a64;\r\n  font-size: 12px;\r\n}\r\n\r\n.cpa-table-empty p {\r\n  margin: 3px 0 0;\r\n  font-size: 10px;\r\n}\r\n\r\n.cpa-table-footnote {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 7px;\r\n  padding: 11px 15px;\r\n  border-top: 1px solid #edf0f2;\r\n  color: #7d8790;\r\n  font-size: 10px;\r\n  line-height: 1.45;\r\n}\r\n\r\n/* ============================================================\r\n   META BAR\r\n   ============================================================ */\r\n\r\n.cpa-meta-bar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n  padding: 9px 2px;\r\n  color: #929ba3;\r\n  font-size: 9px;\r\n}\r\n\r\n/* ============================================================\r\n   EMPTY STATE\r\n   ============================================================ */\r\n\r\n.cpa-empty-state {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  min-height: 300px;\r\n  padding: 40px 20px;\r\n  border: 1px dashed #d5dce0;\r\n  border-radius: 13px;\r\n  background: rgba(255, 255, 255, 0.55);\r\n  text-align: center;\r\n}\r\n\r\n.cpa-es-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 46px;\r\n  height: 46px;\r\n  margin-bottom: 14px;\r\n  border-radius: 12px;\r\n  background: var(--cpa-primary-soft);\r\n  color: var(--cpa-primary);\r\n  font-size: 22px;\r\n  font-weight: 700;\r\n}\r\n\r\n.cpa-es-title {\r\n  color: #45515b;\r\n  font-size: 13px;\r\n  font-weight: 750;\r\n}\r\n\r\n.cpa-es-sub {\r\n  max-width: 500px;\r\n  margin-top: 6px;\r\n  color: #929ba3;\r\n  font-size: 11px;\r\n}\r\n\r\n/* ============================================================\r\n   SKELETON\r\n   ============================================================ */\r\n\r\n.cpa-skeleton-wrap {\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.cpa-sk-cards {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 13px;\r\n  margin-bottom: 13px;\r\n}\r\n\r\n.cpa-sk-block {\r\n  position: relative;\r\n  overflow: hidden;\r\n  border-radius: 10px;\r\n  background: #e9edef;\r\n}\r\n\r\n.cpa-sk-block::after {\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  content: \"\";\r\n  background: linear-gradient(\r\n    90deg,\r\n    transparent,\r\n    rgba(255, 255, 255, 0.65),\r\n    transparent\r\n  );\r\n  animation: cpa-shimmer 1.25s infinite;\r\n}\r\n\r\n@keyframes cpa-shimmer {\r\n  100% {\r\n    left: 100%;\r\n  }\r\n}\r\n\r\n.cpa-sk-card {\r\n  height: 132px;\r\n}\r\n\r\n.cpa-sk-progress {\r\n  height: 130px;\r\n  margin-bottom: 13px;\r\n}\r\n\r\n.cpa-sk-term-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 13px;\r\n  margin-bottom: 13px;\r\n}\r\n\r\n.cpa-sk-term {\r\n  height: 115px;\r\n}\r\n\r\n.cpa-sk-table {\r\n  height: 300px;\r\n}\r\n\r\n/* ============================================================\r\n   PRINT\r\n   ============================================================ */\r\n\r\n@media print {\r\n  .cpa-app {\r\n    padding: 0;\r\n    background: #fff;\r\n  }\r\n\r\n  .cpa-panel,\r\n  .cpa-banner,\r\n  .cpa-selection-count {\r\n    display: none !important;\r\n  }\r\n\r\n  .cpa-masthead {\r\n    margin-bottom: 15px;\r\n  }\r\n\r\n  .cpa-course-context {\r\n    box-shadow: none;\r\n  }\r\n\r\n  .cpa-summary-card,\r\n  .cpa-progress-card,\r\n  .cpa-term-card,\r\n  .cpa-table-card {\r\n    box-shadow: none;\r\n    break-inside: avoid;\r\n  }\r\n\r\n  .cpa-table-scroll {\r\n    overflow: visible;\r\n  }\r\n\r\n  .cpa-analytics-table {\r\n    width: 100%;\r\n    font-size: 8px;\r\n  }\r\n\r\n  .cpa-sticky-col {\r\n    position: static;\r\n  }\r\n\r\n  .cpa-meta-bar {\r\n    margin-top: 10px;\r\n  }\r\n}\r\n\r\n/* ============================================================\r\n   TABLET\r\n   ============================================================ */\r\n\r\n@media (max-width: 1100px) {\r\n  .cpa-app {\r\n    padding: 22px;\r\n  }\r\n\r\n  .cpa-panel-grid {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n\r\n  .cpa-actions {\r\n    grid-column: 1 / -1;\r\n  }\r\n\r\n  .cpa-summary-cards {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .cpa-sk-cards {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n}\r\n\r\n/* ============================================================\r\n   MOBILE\r\n   ============================================================ */\r\n\r\n@media (max-width: 700px) {\r\n  .cpa-app {\r\n    padding: 14px;\r\n  }\r\n\r\n  .cpa-masthead {\r\n    flex-direction: column;\r\n    gap: 13px;\r\n  }\r\n\r\n  .cpa-course-context {\r\n    width: 100%;\r\n    min-width: 0;\r\n    max-width: none;\r\n  }\r\n\r\n  .cpa-panel {\r\n    padding: 14px;\r\n  }\r\n\r\n  .cpa-panel-header {\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n  }\r\n\r\n  .cpa-panel-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .cpa-actions {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n\r\n  .cpa-btn-primary {\r\n    grid-column: 1 / -1;\r\n  }\r\n\r\n  .cpa-btn-ghost {\r\n    width: 100%;\r\n  }\r\n\r\n  .cpa-summary-cards {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .cpa-summary-card {\r\n    min-height: 105px;\r\n  }\r\n\r\n  .cpa-dashboard-context {\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    gap: 6px;\r\n  }\r\n\r\n  .cpa-dashboard-meta {\r\n    text-align: left;\r\n  }\r\n\r\n  .cpa-progress-card {\r\n    padding: 15px;\r\n  }\r\n\r\n  .cpa-progress-header {\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .cpa-pc-pct {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .cpa-section-header,\r\n  .cpa-table-heading {\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n  }\r\n\r\n  .cpa-term-cards {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .cpa-table-card {\r\n    border-radius: 10px;\r\n  }\r\n\r\n  .cpa-table-scroll {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .cpa-analytics-table th:first-child,\r\n  .cpa-analytics-table td:first-child {\r\n    min-width: 190px;\r\n  }\r\n\r\n  .cpa-sticky-reg {\r\n    left: 190px;\r\n  }\r\n\r\n  .cpa-sticky-paid {\r\n    left: 272px;\r\n  }\r\n\r\n  .cpa-sticky-pending {\r\n    left: 354px;\r\n  }\r\n\r\n  .cpa-tech-name {\r\n    max-width: 145px;\r\n  }\r\n\r\n  .cpa-meta-bar {\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    gap: 5px;\r\n  }\r\n\r\n  .cpa-sk-cards {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .cpa-sk-term-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n/* ============================================================\r\n   FINAL REFERENCE LAYOUT OVERRIDES\r\n   Blue / Navy dashboard + larger, aligned table typography\r\n   ============================================================ */\r\n\r\n/* ---------- Overall page ---------- */\r\n.cpa-app {\r\n  background: #f5f8fb;\r\n}\r\n\r\n/* ---------- Main title ---------- */\r\n.cpa-masthead {\r\n  background: #173f63;\r\n  min-height: 58px;\r\n  margin: -28px -28px 22px;\r\n  padding: 0 28px;\r\n  align-items: center;\r\n}\r\n\r\n.cpa-masthead h1 {\r\n  color: #ffffff;\r\n  font-size: clamp(22px, 2.6vw, 30px);\r\n  font-weight: 800;\r\n  letter-spacing: -0.02em;\r\n}\r\n\r\n.cpa-eyebrow {\r\n  color: #dcecf8;\r\n}\r\n\r\n.cpa-sub {\r\n  color: rgba(255, 255, 255, 0.82);\r\n}\r\n\r\n/* ---------- Course context ---------- */\r\n.cpa-course-context {\r\n  border-color: #d7d7d7;\r\n  border-radius: 6px;\r\n  box-shadow: none;\r\n}\r\n\r\n.cpa-cmeta {\r\n  color: #347cb5;\r\n}\r\n\r\n/* ---------- Controls ---------- */\r\n.cpa-panel {\r\n  border-radius: 6px;\r\n  box-shadow: 0 2px 8px rgba(23, 63, 99, 0.06);\r\n}\r\n\r\n.cpa-control:focus,\r\n.cpa-term-trigger:focus {\r\n  border-color: #347cb5;\r\n  box-shadow: 0 0 0 3px rgba(52, 124, 181, 0.12);\r\n}\r\n\r\n.cpa-btn-primary {\r\n  border-color: #347cb5;\r\n  background: #347cb5;\r\n  box-shadow: 0 3px 8px rgba(52, 124, 181, 0.18);\r\n}\r\n\r\n.cpa-btn-primary:hover:not(:disabled) {\r\n  background: #286a9f;\r\n}\r\n\r\n.cpa-btn-ghost {\r\n  border-color: #c5ddec;\r\n  background: #dcecf8;\r\n  color: #173f63;\r\n}\r\n\r\n/* ---------- Summary cards ---------- */\r\n.cpa-summary-cards {\r\n  gap: 0;\r\n  margin-bottom: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.cpa-summary-card {\r\n  min-height: 88px;\r\n  padding: 12px 14px;\r\n  border: 1px solid rgba(255,255,255,0.35);\r\n  border-radius: 0;\r\n  background: #347cb5;\r\n  color: #ffffff;\r\n  box-shadow: none;\r\n  align-items: center;\r\n}\r\n\r\n.cpa-summary-card.cpa-primary-metric {\r\n  border-color: rgba(255,255,255,0.35);\r\n  box-shadow: none;\r\n}\r\n\r\n.cpa-sc-icon {\r\n  width: 34px;\r\n  height: 34px;\r\n  flex: 0 0 34px;\r\n}\r\n\r\n.cpa-summary-card .cpa-sc-label {\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n}\r\n\r\n.cpa-summary-card .cpa-sc-value {\r\n  margin-top: 4px;\r\n  color: #ffffff;\r\n  font-size: 24px;\r\n  font-weight: 800;\r\n}\r\n\r\n.cpa-summary-card .cpa-sc-desc {\r\n  color: rgba(255,255,255,0.82);\r\n}\r\n\r\n.cpa-summary-card.cpa-pending {\r\n  background: #6ead4f;\r\n}\r\n\r\n.cpa-summary-card .cpa-icon-neutral,\r\n.cpa-summary-card .cpa-icon-paid,\r\n.cpa-summary-card .cpa-icon-pending,\r\n.cpa-summary-card .cpa-icon-pct {\r\n  background: rgba(255,255,255,0.14);\r\n  color: #ffffff;\r\n}\r\n\r\n/* ---------- Progress ---------- */\r\n.cpa-progress-card {\r\n  margin-bottom: 18px;\r\n  border-radius: 0 0 6px 6px;\r\n  box-shadow: none;\r\n}\r\n\r\n.cpa-progress-fill {\r\n  background: #347cb5;\r\n}\r\n\r\n/* ---------- Section headings ---------- */\r\n.cpa-section-title,\r\n.cpa-pc-title,\r\n.cpa-dashboard-course {\r\n  color: #173f63;\r\n}\r\n\r\n.cpa-section-kicker,\r\n.cpa-dashboard-term-line span {\r\n  color: #347cb5;\r\n}\r\n\r\n/* ---------- Term cards ---------- */\r\n.cpa-term-card {\r\n  border-radius: 6px;\r\n  border-top: 3px solid #347cb5;\r\n  box-shadow: none;\r\n}\r\n\r\n.cpa-tc-percent,\r\n.cpa-tc-paid {\r\n  color: #347cb5;\r\n}\r\n\r\n.cpa-tc-pending {\r\n  color: #5f8f43;\r\n}\r\n\r\n.cpa-tc-progress-fill {\r\n  background: #347cb5;\r\n}\r\n\r\n/* ============================================================\r\n   MAIN ANALYTICS TABLE\r\n   ============================================================ */\r\n\r\n.cpa-table-card {\r\n  border-radius: 6px;\r\n  box-shadow: none;\r\n}\r\n\r\n.cpa-table-heading {\r\n  padding: 13px 16px;\r\n  background: #ffffff;\r\n}\r\n\r\n.cpa-analytics-table {\r\n  font-size: 15px;\r\n  color: #17202a;\r\n}\r\n\r\n.cpa-analytics-table th,\r\n.cpa-analytics-table td {\r\n  min-width: 82px;\r\n  height: 44px;\r\n  padding: 9px 10px;\r\n  border-right: 1px solid #d7d7d7;\r\n  border-bottom: 1px solid #d7d7d7;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Batch / Technology */\r\n.cpa-analytics-table th:first-child,\r\n.cpa-analytics-table td:first-child {\r\n  min-width: 250px;\r\n  text-align: center;\r\n}\r\n\r\n.cpa-analytics-table th {\r\n  height: 42px;\r\n  color: #ffffff;\r\n  background: #347cb5;\r\n  font-size: 14px;\r\n  font-weight: 800;\r\n  letter-spacing: 0;\r\n  text-transform: none;\r\n}\r\n\r\n.cpa-analytics-table thead tr:first-child th,\r\n.cpa-analytics-table thead tr:last-child th {\r\n  height: 42px;\r\n  background: #347cb5;\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n}\r\n\r\n/* Term group headers */\r\n.cpa-term-group-header {\r\n  background: #286a9f !important;\r\n  color: #ffffff !important;\r\n  border-bottom-color: #d7d7d7 !important;\r\n}\r\n\r\n.cpa-sub-header th {\r\n  background: #347cb5 !important;\r\n  color: #ffffff !important;\r\n}\r\n\r\n/* ---------- Sticky columns ---------- */\r\n.cpa-sticky-col {\r\n  background: #ffffff;\r\n}\r\n\r\n.cpa-analytics-table thead .cpa-sticky-col {\r\n  background: #347cb5;\r\n}\r\n\r\n.cpa-sticky-reg {\r\n  left: 250px;\r\n}\r\n\r\n.cpa-sticky-paid {\r\n  left: 332px;\r\n}\r\n\r\n.cpa-sticky-pending {\r\n  left: 414px;\r\n}\r\n\r\n/* ---------- Technology cell ---------- */\r\n.cpa-tech-cell {\r\n  min-height: 44px;\r\n  justify-content: center;\r\n  text-align: center;\r\n}\r\n\r\n.cpa-tech-name {\r\n  max-width: 205px;\r\n  color: #17202a;\r\n  font-size: 15px;\r\n  font-weight: 650;\r\n  line-height: 1.3;\r\n  text-align: center;\r\n}\r\n\r\n/* ---------- Registration ---------- */\r\n.cpa-analytics-table td:nth-child(2),\r\n.cpa-analytics-table th:nth-child(2) {\r\n  text-align: center !important;\r\n  font-size: 15px;\r\n  font-weight: 650;\r\n}\r\n\r\n/* ---------- PAID: explicit center alignment ---------- */\r\n.cpa-analytics-table td:nth-child(3),\r\n.cpa-analytics-table th:nth-child(3),\r\n.cpa-cell-paid,\r\n.cpa-sticky-paid {\r\n  text-align: center !important;\r\n  vertical-align: middle !important;\r\n}\r\n\r\n.cpa-cell-paid {\r\n  color: #173f63;\r\n  font-size: 16px;\r\n  font-weight: 750;\r\n  line-height: 1.2;\r\n}\r\n\r\n/* ---------- PENDING ---------- */\r\n.cpa-analytics-table td:nth-child(4),\r\n.cpa-analytics-table th:nth-child(4),\r\n.cpa-cell-pending,\r\n.cpa-sticky-pending {\r\n  text-align: center !important;\r\n  vertical-align: middle !important;\r\n}\r\n\r\n.cpa-cell-pending {\r\n  color: #34404a;\r\n  font-size: 16px;\r\n  font-weight: 650;\r\n  line-height: 1.2;\r\n}\r\n\r\n/* ---------- Percentages ---------- */\r\n.cpa-cell-pct {\r\n  color: #173f63;\r\n  font-size: 15px;\r\n  font-weight: 750;\r\n  text-align: center !important;\r\n  vertical-align: middle !important;\r\n}\r\n\r\n/* ---------- Overall row ---------- */\r\n.cpa-overall-row td {\r\n  height: 46px;\r\n  background: #dcecf8;\r\n  color: #173f63;\r\n  font-size: 15px;\r\n  font-weight: 750;\r\n  border-bottom-color: #bfdced;\r\n}\r\n\r\n.cpa-overall-row .cpa-sticky-col {\r\n  background: #dcecf8;\r\n}\r\n\r\n.cpa-overall-row:hover td {\r\n  background: #dcecf8 !important;\r\n}\r\n\r\n.cpa-overall-label {\r\n  justify-content: center;\r\n  color: #173f63;\r\n  font-size: 15px;\r\n  font-weight: 800;\r\n}\r\n\r\n.cpa-overall-dot {\r\n  background: #347cb5;\r\n}\r\n\r\n.cpa-term-overall-cell {\r\n  background: #dcecf8 !important;\r\n}\r\n\r\n/* ---------- Table progress bars ---------- */\r\n.cpa-mini-progress {\r\n  height: 5px;\r\n  background: #e4eef5;\r\n}\r\n\r\n.cpa-mini-progress div {\r\n  background: #347cb5;\r\n}\r\n\r\n/* ---------- Table empty ---------- */\r\n.cpa-table-empty {\r\n  font-size: 13px;\r\n}\r\n\r\n/* ============================================================\r\n   RESPONSIVE STICKY OFFSETS\r\n   ============================================================ */\r\n\r\n@media (max-width: 700px) {\r\n  .cpa-masthead {\r\n    margin: -14px -14px 18px;\r\n    padding: 0 14px;\r\n  }\r\n\r\n  .cpa-analytics-table {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .cpa-analytics-table th,\r\n  .cpa-analytics-table td {\r\n    height: 42px;\r\n    padding: 8px 9px;\r\n  }\r\n\r\n  .cpa-analytics-table th:first-child,\r\n  .cpa-analytics-table td:first-child {\r\n    min-width: 205px;\r\n  }\r\n\r\n  .cpa-sticky-reg {\r\n    left: 205px;\r\n  }\r\n\r\n  .cpa-sticky-paid {\r\n    left: 287px;\r\n  }\r\n\r\n  .cpa-sticky-pending {\r\n    left: 369px;\r\n  }\r\n\r\n  .cpa-tech-name {\r\n    max-width: 160px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .cpa-cell-paid,\r\n  .cpa-cell-pending {\r\n    font-size: 15px;\r\n  }\r\n}\r\n\r\n/* ============================================================\r\n   COMPACT DASHBOARD LAYOUT\r\n   Remove Overall Payment Progress + reduce unnecessary spacing\r\n   ============================================================ */\r\n\r\n/* ------------------------------------------------------------\r\n   1. REMOVE OVERALL PAYMENT PROGRESS SECTION\r\n   ------------------------------------------------------------ */\r\n\r\n.cpa-progress-card {\r\n    display: none !important;\r\n}\r\n\r\n\r\n/* ------------------------------------------------------------\r\n   2. REMOVE EXTRA SPACE BEFORE TERM-WISE SECTION\r\n   ------------------------------------------------------------ */\r\n\r\n.cpa-section {\r\n    margin-bottom: 14px;\r\n}\r\n\r\n.cpa-section-header {\r\n    margin-bottom: 8px;\r\n}\r\n\r\n\r\n/* ------------------------------------------------------------\r\n   3. TERM-WISE SECTION\r\n   Make it immediately follow the previous section\r\n   ------------------------------------------------------------ */\r\n\r\n.cpa-section:has(.cpa-term-cards) {\r\n    margin-top: 0 !important;\r\n    padding-top: 0 !important;\r\n}\r\n\r\n\r\n/* ------------------------------------------------------------\r\n   4. TERM CARDS\r\n   Equal width, compact spacing\r\n   ------------------------------------------------------------ */\r\n\r\n.cpa-term-cards {\r\n    display: grid;\r\n\r\n    grid-template-columns:\r\n        repeat(2, minmax(0, 1fr));\r\n\r\n    gap: 10px;\r\n\r\n    width: 100%;\r\n\r\n    margin: 0;\r\n\r\n    padding: 0;\r\n}\r\n\r\n\r\n/* ------------------------------------------------------------\r\n   5. INDIVIDUAL TERM CARD\r\n   ------------------------------------------------------------ */\r\n\r\n.cpa-term-card {\r\n    width: 100%;\r\n\r\n    min-width: 0;\r\n\r\n    margin: 0;\r\n\r\n    padding: 12px 14px;\r\n\r\n    border: 1px solid #d7d7d7;\r\n\r\n    border-top: 3px solid #347cb5;\r\n\r\n    border-radius: 5px;\r\n\r\n    background: #ffffff;\r\n\r\n    box-shadow: none;\r\n\r\n    box-sizing: border-box;\r\n}\r\n\r\n\r\n/* ------------------------------------------------------------\r\n   6. TERM HEADER\r\n   ------------------------------------------------------------ */\r\n\r\n.cpa-tc-header {\r\n    display: flex;\r\n\r\n    align-items: center;\r\n\r\n    justify-content: space-between;\r\n\r\n    gap: 10px;\r\n\r\n    padding: 0 0 8px;\r\n\r\n    border-bottom: 1px solid #e5e9ed;\r\n}\r\n\r\n\r\n/* Term name */\r\n.cpa-tc-name {\r\n    margin: 0;\r\n\r\n    color: #173f63;\r\n\r\n    font-size: 14px;\r\n\r\n    font-weight: 700;\r\n\r\n    line-height: 1.2;\r\n}\r\n\r\n\r\n/* Percentage */\r\n.cpa-tc-percent {\r\n    margin: 0;\r\n\r\n    color: #347cb5;\r\n\r\n    font-size: 14px;\r\n\r\n    font-weight: 800;\r\n\r\n    line-height: 1.2;\r\n}\r\n\r\n\r\n/* ------------------------------------------------------------\r\n   7. TERM CARD CONTENT\r\n   ------------------------------------------------------------ */\r\n\r\n.cpa-tc-main {\r\n    display: flex;\r\n\r\n    align-items: center;\r\n\r\n    gap: 28px;\r\n\r\n    padding: 10px 0 8px;\r\n\r\n    margin: 0;\r\n}\r\n\r\n\r\n/* ------------------------------------------------------------\r\n   8. PAID / PENDING\r\n   ------------------------------------------------------------ */\r\n\r\n.cpa-tc-stat {\r\n    display: flex;\r\n\r\n    flex-direction: column;\r\n\r\n    justify-content: center;\r\n\r\n    gap: 3px;\r\n\r\n    min-width: 55px;\r\n\r\n    margin: 0;\r\n}\r\n\r\n\r\n.cpa-tc-stat-label {\r\n    margin: 0;\r\n\r\n    color: #7b8791;\r\n\r\n    font-size: 9px;\r\n\r\n    font-weight: 800;\r\n\r\n    line-height: 1.1;\r\n\r\n    text-transform: uppercase;\r\n}\r\n\r\n\r\n.cpa-tc-stat strong {\r\n    margin: 0;\r\n\r\n    font-size: 20px;\r\n\r\n    font-weight: 800;\r\n\r\n    line-height: 1;\r\n}\r\n\r\n\r\n/* Paid */\r\n.cpa-tc-paid {\r\n    color: #286a9f;\r\n}\r\n\r\n\r\n/* Pending */\r\n.cpa-tc-pending {\r\n    color: #5d963f;\r\n}\r\n\r\n\r\n/* ------------------------------------------------------------\r\n   9. DIVIDER BETWEEN PAID AND PENDING\r\n   ------------------------------------------------------------ */\r\n\r\n.cpa-tc-divider {\r\n    width: 1px;\r\n\r\n    height: 34px;\r\n\r\n    flex: 0 0 1px;\r\n\r\n    margin: 0;\r\n\r\n    background: #dfe4e8;\r\n}\r\n\r\n\r\n/* ------------------------------------------------------------\r\n   10. TERM PROGRESS BAR\r\n   ------------------------------------------------------------ */\r\n\r\n.cpa-tc-progress-track {\r\n    width: 100%;\r\n\r\n    height: 5px;\r\n\r\n    margin: 0;\r\n\r\n    overflow: hidden;\r\n\r\n    border-radius: 3px;\r\n\r\n    background: #e8edf1;\r\n}\r\n\r\n\r\n.cpa-tc-progress-fill {\r\n    height: 100%;\r\n\r\n    margin: 0;\r\n\r\n    border-radius: 3px;\r\n\r\n    background: #347cb5;\r\n}\r\n\r\n\r\n/* ------------------------------------------------------------\r\n   11. REMOVE EMPTY TERM CARD SPACE\r\n   ------------------------------------------------------------ */\r\n\r\n.cpa-term-cards-empty {\r\n    margin: 0;\r\n\r\n    padding: 14px;\r\n\r\n    border-radius: 5px;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   12. SECTION TITLE — COMPACT\r\n   ============================================================ */\r\n\r\n.cpa-section-header {\r\n    display: flex;\r\n\r\n    align-items: center;\r\n\r\n    justify-content: space-between;\r\n\r\n    gap: 10px;\r\n\r\n    margin-top: 0;\r\n\r\n    margin-bottom: 8px;\r\n\r\n    padding: 0;\r\n}\r\n\r\n\r\n.cpa-section-title {\r\n    margin: 0;\r\n\r\n    color: #173f63;\r\n\r\n    font-size: 16px;\r\n\r\n    font-weight: 750;\r\n\r\n    line-height: 1.2;\r\n}\r\n\r\n\r\n/* Small \"Individual term results\" label */\r\n.cpa-section-header .cpa-tag {\r\n    margin: 0;\r\n\r\n    padding: 4px 7px;\r\n\r\n    font-size: 9px;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   13. DASHBOARD CONTEXT — REMOVE EXTRA SPACE\r\n   ============================================================ */\r\n\r\n.cpa-dashboard-context {\r\n    margin-bottom: 10px;\r\n\r\n    gap: 10px;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   14. TERM SECTION ITSELF\r\n   ============================================================ */\r\n\r\n.cpa-section:has(.cpa-term-cards) {\r\n    margin-bottom: 14px;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   15. TABLE SHOULD FOLLOW TERM CARDS CLOSELY\r\n   ============================================================ */\r\n\r\n.cpa-table-card {\r\n    margin-top: 0;\r\n\r\n    margin-bottom: 14px;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   16. RESPONSIVE\r\n   ============================================================ */\r\n\r\n@media (max-width: 700px) {\r\n\r\n    .cpa-term-cards {\r\n        grid-template-columns: 1fr;\r\n\r\n        gap: 8px;\r\n    }\r\n\r\n    .cpa-term-card {\r\n        padding: 11px 12px;\r\n    }\r\n\r\n    .cpa-tc-main {\r\n        gap: 20px;\r\n    }\r\n}\r\n\r\n\r\n/* ============================================================\r\n   17. VERY SMALL SCREENS\r\n   ============================================================ */\r\n\r\n@media (max-width: 420px) {\r\n\r\n    .cpa-tc-main {\r\n        gap: 16px;\r\n    }\r\n\r\n    .cpa-tc-stat {\r\n        min-width: 48px;\r\n    }\r\n\r\n    .cpa-tc-stat strong {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .cpa-tc-name,\r\n    .cpa-tc-percent {\r\n        font-size: 13px;\r\n    }\r\n}\r\n\r\n/* ============================================================\r\n   FIX TERM-WISE PAID COLUMN WIDTH\r\n   Keep Batch column wide, but Term Paid column compact\r\n   ============================================================ */\r\n\r\n/* Batch / Technology column stays wide */\r\n.cpa-analytics-table thead tr:first-child th:first-child {\r\n    min-width: 250px;\r\n    width: 250px;\r\n}\r\n\r\n/* Second header row:\r\n   Paid must NOT inherit the Batch column width */\r\n.cpa-analytics-table .cpa-sub-header th:first-child {\r\n    min-width: 82px !important;\r\n    width: 82px !important;\r\n    max-width: 82px !important;\r\n\r\n    padding-left: 8px !important;\r\n    padding-right: 8px !important;\r\n\r\n    text-align: center !important;\r\n}\r\n\r\n/* All Term-wise numeric columns remain compact */\r\n.cpa-analytics-table .cpa-sub-header th {\r\n    min-width: 82px !important;\r\n    width: 82px !important;\r\n    max-width: 100px;\r\n}\r\n\r\n/* Term 1 Paid body cells */\r\n.cpa-analytics-table td.cpa-cell-paid {\r\n    min-width: 82px !important;\r\n    width: 82px !important;\r\n    max-width: 100px !important;\r\n\r\n    padding-left: 6px !important;\r\n    padding-right: 6px !important;\r\n\r\n    text-align: center !important;\r\n}\r\n\r\n/* Keep Paid number centered */\r\n.cpa-cell-paid {\r\n    display: table-cell;\r\n\r\n    text-align: center !important;\r\n    vertical-align: middle !important;\r\n\r\n    font-size: 15px !important;\r\n    font-weight: 750 !important;\r\n}\r\n\r\n/* Term-wise columns */\r\n.cpa-analytics-table td.cpa-cell-pending,\r\n.cpa-analytics-table td.cpa-cell-pct,\r\n.cpa-analytics-table td.cpa-cell-share {\r\n    min-width: 82px !important;\r\n\r\n    padding-left: 6px !important;\r\n    padding-right: 6px !important;\r\n\r\n    text-align: center !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   PREVENT FIRST-CHILD RULE FROM AFFECTING TERM HEADERS\r\n   ============================================================ */\r\n\r\n.cpa-analytics-table .cpa-sub-header th:first-child {\r\n    min-width: 82px !important;\r\n    width: 82px !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   TERM GROUPS — CONSISTENT COLUMN WIDTH\r\n   ============================================================ */\r\n\r\n.cpa-analytics-table th,\r\n.cpa-analytics-table td {\r\n    box-sizing: border-box;\r\n}\r\n\r\n.cpa-analytics-table .cpa-term-group-header {\r\n    text-align: center !important;\r\n    vertical-align: middle !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   IF STICKY PAID COLUMN IS USED\r\n   ============================================================ */\r\n\r\n.cpa-sticky-paid {\r\n    left: 332px;\r\n    min-width: 82px !important;\r\n    width: 82px !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   MOBILE\r\n   ============================================================ */\r\n\r\n@media (max-width: 700px) {\r\n\r\n    .cpa-analytics-table .cpa-sub-header th:first-child {\r\n        min-width: 76px !important;\r\n        width: 76px !important;\r\n    }\r\n\r\n    .cpa-analytics-table td.cpa-cell-paid {\r\n        min-width: 76px !important;\r\n        width: 76px !important;\r\n    }\r\n}\r\n\r\n/* ============================================================\r\n   HEADER + COURSE NAME — FINAL TYPOGRAPHY UPDATE\r\n   ============================================================ */\r\n\r\n.cpa-masthead {\r\n    background: #173f63;\r\n\r\n    min-height: 68px;\r\n\r\n    margin: -28px -28px 20px;\r\n\r\n    padding: 10px 28px;\r\n\r\n    display: flex;\r\n\r\n    align-items: center;\r\n\r\n    box-sizing: border-box;\r\n}\r\n\r\n\r\n/* Main dashboard title */\r\n.cpa-masthead h1 {\r\n    margin: 0;\r\n\r\n    color: #ffffff;\r\n\r\n    font-size: 27px !important;\r\n\r\n    font-weight: 800 !important;\r\n\r\n    line-height: 1.2;\r\n\r\n    letter-spacing: 0;\r\n\r\n    white-space: nowrap;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   COURSE NAME\r\n   ============================================================ */\r\n\r\n.cpa-dashboard-context {\r\n    margin-top: 0 !important;\r\n\r\n    margin-bottom: 16px !important;\r\n\r\n    padding: 0 !important;\r\n\r\n    display: flex;\r\n\r\n    align-items: center;\r\n\r\n    gap: 8px;\r\n}\r\n\r\n\r\n/* Course name itself */\r\n.cpa-dashboard-course {\r\n    color: #173f63 !important;\r\n\r\n    font-size: 21px !important;\r\n\r\n    font-weight: 800 !important;\r\n\r\n    line-height: 1.25;\r\n\r\n    margin: 0 !important;\r\n}\r\n\r\n\r\n/* Course metadata / selected terms */\r\n.cpa-dashboard-term-line {\r\n    margin-top: 4px;\r\n\r\n    color: #52606d;\r\n\r\n    font-size: 14px !important;\r\n\r\n    font-weight: 500;\r\n\r\n    line-height: 1.3;\r\n}\r\n\r\n\r\n/* Small labels inside course context */\r\n.cpa-dashboard-term-line span {\r\n    color: #347cb5;\r\n\r\n    font-size: 13px !important;\r\n\r\n    font-weight: 700;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   SECTION TITLES\r\n   ============================================================ */\r\n\r\n.cpa-section-title {\r\n    color: #173f63 !important;\r\n\r\n    font-size: 19px !important;\r\n\r\n    font-weight: 800 !important;\r\n\r\n    line-height: 1.25;\r\n\r\n    margin: 0 !important;\r\n}\r\n\r\n\r\n/* Section small heading / kicker */\r\n.cpa-section-kicker {\r\n    color: #347cb5 !important;\r\n\r\n    font-size: 12px !important;\r\n\r\n    font-weight: 800 !important;\r\n\r\n    letter-spacing: 0.08em;\r\n\r\n    text-transform: uppercase;\r\n\r\n    margin-bottom: 3px;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   SUMMARY CARD FONT SIZES\r\n   ============================================================ */\r\n\r\n.cpa-summary-card .cpa-sc-label {\r\n    color: #ffffff;\r\n\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 800 !important;\r\n}\r\n\r\n.cpa-summary-card .cpa-sc-value {\r\n    color: #ffffff;\r\n\r\n    font-size: 25px !important;\r\n\r\n    font-weight: 800 !important;\r\n\r\n    line-height: 1.1;\r\n}\r\n\r\n.cpa-summary-card .cpa-sc-desc {\r\n    font-size: 12px !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   TERM CARD FONT SIZES\r\n   ============================================================ */\r\n\r\n.cpa-tc-name {\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 800 !important;\r\n}\r\n\r\n.cpa-tc-percent {\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 800 !important;\r\n}\r\n\r\n.cpa-tc-stat-label {\r\n    font-size: 10px !important;\r\n\r\n    font-weight: 800 !important;\r\n}\r\n\r\n.cpa-tc-stat strong {\r\n    font-size: 21px !important;\r\n\r\n    font-weight: 800 !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   TABLE FONT SIZES\r\n   ============================================================ */\r\n\r\n.cpa-analytics-table th {\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 800 !important;\r\n}\r\n\r\n.cpa-analytics-table td {\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 600;\r\n}\r\n\r\n\r\n/* Batch / technology name */\r\n.cpa-tech-name {\r\n    font-size: 16px !important;\r\n\r\n    font-weight: 700 !important;\r\n}\r\n\r\n\r\n/* Paid */\r\n.cpa-cell-paid {\r\n    font-size: 17px !important;\r\n\r\n    font-weight: 800 !important;\r\n\r\n    text-align: center !important;\r\n\r\n    vertical-align: middle !important;\r\n}\r\n\r\n\r\n/* Pending */\r\n.cpa-cell-pending {\r\n    font-size: 17px !important;\r\n\r\n    font-weight: 700 !important;\r\n\r\n    text-align: center !important;\r\n\r\n    vertical-align: middle !important;\r\n}\r\n\r\n\r\n/* Payment % */\r\n.cpa-cell-pct {\r\n    font-size: 16px !important;\r\n\r\n    font-weight: 800 !important;\r\n\r\n    text-align: center !important;\r\n}\r\n\r\n\r\n/* Overall row */\r\n.cpa-overall-row td {\r\n    font-size: 16px !important;\r\n\r\n    font-weight: 800 !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   MOBILE\r\n   ============================================================ */\r\n\r\n@media (max-width: 700px) {\r\n\r\n    .cpa-masthead {\r\n        min-height: 62px;\r\n\r\n        margin: -14px -14px 16px;\r\n\r\n        padding: 10px 14px;\r\n    }\r\n\r\n    .cpa-masthead h1 {\r\n        font-size: 21px !important;\r\n\r\n        white-space: normal;\r\n    }\r\n\r\n    .cpa-dashboard-course {\r\n        font-size: 18px !important;\r\n    }\r\n\r\n    .cpa-section-title {\r\n        font-size: 17px !important;\r\n    }\r\n\r\n    .cpa-analytics-table th {\r\n        font-size: 14px !important;\r\n    }\r\n\r\n    .cpa-analytics-table td {\r\n        font-size: 14px !important;\r\n    }\r\n\r\n    .cpa-cell-paid,\r\n    .cpa-cell-pending {\r\n        font-size: 16px !important;\r\n    }\r\n}\r\n\r\n/* ============================================================\r\n   FINAL UI UPDATE\r\n   - Match the provided DRIVE READY 2028 header reference\r\n   - Larger typography without making it excessively bold\r\n   - Larger course name\r\n   - Remove A/B/C/D/F/M technology initials\r\n   - Overall Share shows a meaningful 100.00%\r\n   - Preserve compact table alignment\r\n   ============================================================ */\r\n\r\n\r\n/* ============================================================\r\n   1. MAIN HEADER — MATCH REFERENCE IMAGE\r\n   ============================================================ */\r\n\r\n.cpa-masthead {\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    min-height: 58px;\r\n\r\n    margin: -28px -28px 18px;\r\n\r\n    padding: 0 22px;\r\n\r\n    background: #173f63;\r\n\r\n    border-bottom: 4px solid #dcecf8;\r\n\r\n    box-sizing: border-box;\r\n}\r\n\r\n\r\n/* Main title */\r\n.cpa-masthead h1 {\r\n    margin: 0 !important;\r\n\r\n    color: #ffffff !important;\r\n\r\n    font-size: 30px !important;\r\n\r\n    font-weight: 700 !important;\r\n\r\n    letter-spacing: 0 !important;\r\n\r\n    line-height: 1.15 !important;\r\n\r\n    white-space: nowrap;\r\n}\r\n\r\n\r\n/* Hide the small eyebrow if it is displayed above the title.\r\n   The reference image is a clean single-line title. */\r\n.cpa-eyebrow {\r\n    display: none;\r\n}\r\n\r\n\r\n/* Do not show the old subtitle inside the blue header */\r\n.cpa-masthead .cpa-sub {\r\n    display: none;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   2. COURSE NAME — BIGGER BUT NOT HEAVY\r\n   ============================================================ */\r\n\r\n.cpa-dashboard-context {\r\n    display: flex;\r\n\r\n    align-items: flex-start;\r\n\r\n    justify-content: space-between;\r\n\r\n    gap: 20px;\r\n\r\n    margin-top: 0 !important;\r\n\r\n    margin-bottom: 12px !important;\r\n\r\n    padding: 0 !important;\r\n}\r\n\r\n\r\n.cpa-dashboard-course {\r\n    margin: 0 !important;\r\n\r\n    color: #173f63 !important;\r\n\r\n    font-size: 24px !important;\r\n\r\n    font-weight: 650 !important;\r\n\r\n    letter-spacing: -0.01em !important;\r\n\r\n    line-height: 1.2 !important;\r\n}\r\n\r\n\r\n/* Selected terms */\r\n.cpa-dashboard-term-line {\r\n    margin-top: 5px !important;\r\n\r\n    color: #52606d !important;\r\n\r\n    font-size: 13px !important;\r\n\r\n    font-weight: 500 !important;\r\n\r\n    line-height: 1.3 !important;\r\n}\r\n\r\n\r\n.cpa-dashboard-term-line span {\r\n    color: #347cb5 !important;\r\n\r\n    font-size: 13px !important;\r\n\r\n    font-weight: 600 !important;\r\n}\r\n\r\n\r\n/* Last updated text */\r\n.cpa-dashboard-meta {\r\n    color: #7b8791 !important;\r\n\r\n    font-size: 10px !important;\r\n\r\n    font-weight: 400 !important;\r\n\r\n    text-align: right;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   3. REMOVE TECHNOLOGY INITIAL BOXES\r\n   A / C / D / F / M etc.\r\n   ============================================================ */\r\n\r\n.cpa-tech-icon {\r\n    display: none !important;\r\n}\r\n\r\n\r\n/* Remove the gap that was reserved for the icon */\r\n.cpa-tech-cell {\r\n    display: flex;\r\n\r\n    align-items: center;\r\n\r\n    justify-content: center;\r\n\r\n    gap: 0 !important;\r\n\r\n    min-height: 48px;\r\n\r\n    padding-left: 8px;\r\n\r\n    padding-right: 8px;\r\n}\r\n\r\n\r\n/* Technology name */\r\n.cpa-tech-name {\r\n    display: block;\r\n\r\n    max-width: 225px;\r\n\r\n    overflow: hidden;\r\n\r\n    color: #173f63 !important;\r\n\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 600 !important;\r\n\r\n    line-height: 1.25 !important;\r\n\r\n    text-align: center;\r\n\r\n    text-overflow: ellipsis;\r\n\r\n    white-space: normal;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   4. GENERAL TYPOGRAPHY\r\n   Larger font size, controlled weight\r\n   ============================================================ */\r\n\r\n.cpa-summary-card .cpa-sc-label {\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 600 !important;\r\n}\r\n\r\n\r\n.cpa-summary-card .cpa-sc-value {\r\n    font-size: 26px !important;\r\n\r\n    font-weight: 700 !important;\r\n}\r\n\r\n\r\n.cpa-summary-card .cpa-sc-desc {\r\n    font-size: 12px !important;\r\n\r\n    font-weight: 400 !important;\r\n}\r\n\r\n\r\n.cpa-section-kicker {\r\n    font-size: 11px !important;\r\n\r\n    font-weight: 700 !important;\r\n}\r\n\r\n\r\n.cpa-section-title {\r\n    font-size: 18px !important;\r\n\r\n    font-weight: 650 !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   5. TERM CARDS\r\n   ============================================================ */\r\n\r\n.cpa-tc-name {\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 650 !important;\r\n}\r\n\r\n\r\n.cpa-tc-percent {\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 650 !important;\r\n}\r\n\r\n\r\n.cpa-tc-stat-label {\r\n    font-size: 10px !important;\r\n\r\n    font-weight: 600 !important;\r\n}\r\n\r\n\r\n.cpa-tc-stat strong {\r\n    font-size: 21px !important;\r\n\r\n    font-weight: 650 !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   6. TABLE — BIGGER FONT, NOT EXTRA BOLD\r\n   ============================================================ */\r\n\r\n.cpa-analytics-table {\r\n    font-size: 14px !important;\r\n}\r\n\r\n\r\n.cpa-analytics-table th,\r\n.cpa-analytics-table td {\r\n    font-size: 14px !important;\r\n\r\n    font-weight: 500;\r\n\r\n    vertical-align: middle !important;\r\n}\r\n\r\n\r\n/* Header */\r\n.cpa-analytics-table th {\r\n    font-size: 14px !important;\r\n\r\n    font-weight: 650 !important;\r\n}\r\n\r\n\r\n/* Technology / Batch header */\r\n.cpa-analytics-table th:first-child {\r\n    font-size: 14px !important;\r\n\r\n    font-weight: 650 !important;\r\n}\r\n\r\n\r\n/* Registrations */\r\n.cpa-analytics-table td:nth-child(2) {\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 550 !important;\r\n\r\n    text-align: center !important;\r\n}\r\n\r\n\r\n/* Common Paid */\r\n.cpa-analytics-table td:nth-child(3) {\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 600 !important;\r\n\r\n    text-align: center !important;\r\n}\r\n\r\n\r\n/* Common Pending */\r\n.cpa-analytics-table td:nth-child(4) {\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 550 !important;\r\n\r\n    text-align: center !important;\r\n}\r\n\r\n\r\n/* Payment % */\r\n.cpa-cell-pct {\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 600 !important;\r\n\r\n    text-align: center !important;\r\n\r\n    vertical-align: middle !important;\r\n}\r\n\r\n\r\n/* Paid */\r\n.cpa-cell-paid {\r\n    font-size: 16px !important;\r\n\r\n    font-weight: 600 !important;\r\n\r\n    text-align: center !important;\r\n\r\n    vertical-align: middle !important;\r\n}\r\n\r\n\r\n/* Pending */\r\n.cpa-cell-pending {\r\n    font-size: 16px !important;\r\n\r\n    font-weight: 550 !important;\r\n\r\n    text-align: center !important;\r\n\r\n    vertical-align: middle !important;\r\n}\r\n\r\n\r\n/* Share */\r\n.cpa-cell-share {\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 500 !important;\r\n\r\n    text-align: center !important;\r\n\r\n    vertical-align: middle !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   7. OVERALL ROW\r\n   ============================================================ */\r\n\r\n.cpa-overall-row td {\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 650 !important;\r\n}\r\n\r\n\r\n/* Overall label */\r\n.cpa-overall-label {\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 650 !important;\r\n}\r\n\r\n\r\n/* ------------------------------------------------------------\r\n   Overall Share:\r\n   Instead of displaying \"-\" show 100.00%.\r\n\r\n   The Overall row represents the full course total,\r\n   therefore its share is 100%.\r\n   ------------------------------------------------------------ */\r\n\r\n.cpa-overall-row > td:nth-child(6) {\r\n    font-size: 0 !important;\r\n\r\n    text-align: center !important;\r\n}\r\n\r\n\r\n.cpa-overall-row > td:nth-child(6)::after {\r\n    content: \"100.00%\";\r\n\r\n    color: #173f63;\r\n\r\n    font-size: 15px;\r\n\r\n    font-weight: 650;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   8. TERM OVERALL CELLS\r\n   ============================================================ */\r\n\r\n.cpa-term-overall-cell {\r\n    font-size: 15px !important;\r\n\r\n    font-weight: 650 !important;\r\n\r\n    text-align: center !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   9. TABLE HEIGHT / SPACING\r\n   ============================================================ */\r\n\r\n.cpa-analytics-table th,\r\n.cpa-analytics-table td {\r\n    min-height: 44px;\r\n\r\n    padding-top: 9px !important;\r\n\r\n    padding-bottom: 9px !important;\r\n}\r\n\r\n\r\n.cpa-tech-cell {\r\n    min-height: 44px !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   10. TERM CARDS — KEEP COMPACT\r\n   ============================================================ */\r\n\r\n.cpa-term-cards {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\r\n\r\n    gap: 10px !important;\r\n\r\n    margin: 0 !important;\r\n}\r\n\r\n\r\n.cpa-term-card {\r\n    padding: 12px 14px !important;\r\n\r\n    border-radius: 5px !important;\r\n\r\n    box-shadow: none !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   11. SUMMARY CARDS — REFERENCE BLUE\r\n   ============================================================ */\r\n\r\n.cpa-summary-cards {\r\n    gap: 0 !important;\r\n\r\n    margin-bottom: 0 !important;\r\n}\r\n\r\n\r\n.cpa-summary-card {\r\n    min-height: 92px !important;\r\n\r\n    padding: 12px 16px !important;\r\n\r\n    border-radius: 0 !important;\r\n\r\n    background: #347cb5 !important;\r\n\r\n    color: #ffffff !important;\r\n\r\n    box-shadow: none !important;\r\n}\r\n\r\n\r\n.cpa-summary-card.cpa-pending {\r\n    background: #6ead4f !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   12. REMOVE OVERALL PROGRESS\r\n   ============================================================ */\r\n\r\n.cpa-progress-card {\r\n    display: none !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   13. SECTION SPACING\r\n   ============================================================ */\r\n\r\n.cpa-section {\r\n    margin-bottom: 12px !important;\r\n}\r\n\r\n\r\n.cpa-section-header {\r\n    margin-bottom: 7px !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   14. TABLE HEADING\r\n   ============================================================ */\r\n\r\n.cpa-table-heading {\r\n    padding: 12px 14px !important;\r\n}\r\n\r\n\r\n.cpa-table-caption {\r\n    font-size: 10px !important;\r\n\r\n    font-weight: 500 !important;\r\n}\r\n\r\n\r\n/* ============================================================\r\n   15. DESKTOP HEADER WIDTH\r\n   ============================================================ */\r\n\r\n@media (min-width: 1101px) {\r\n\r\n    .cpa-masthead h1 {\r\n        font-size: 30px !important;\r\n    }\r\n\r\n    .cpa-dashboard-course {\r\n        font-size: 25px !important;\r\n    }\r\n}\r\n\r\n\r\n/* ============================================================\r\n   16. TABLET\r\n   ============================================================ */\r\n\r\n@media (max-width: 1100px) {\r\n\r\n    .cpa-masthead h1 {\r\n        font-size: 27px !important;\r\n    }\r\n\r\n    .cpa-dashboard-course {\r\n        font-size: 22px !important;\r\n    }\r\n\r\n    .cpa-tech-name {\r\n        font-size: 14px !important;\r\n    }\r\n}\r\n\r\n\r\n/* ============================================================\r\n   17. MOBILE\r\n   ============================================================ */\r\n\r\n@media (max-width: 700px) {\r\n\r\n    .cpa-masthead {\r\n        min-height: 54px;\r\n\r\n        margin: -14px -14px 16px;\r\n\r\n        padding: 0 14px;\r\n\r\n        border-bottom-width: 3px;\r\n    }\r\n\r\n\r\n    .cpa-masthead h1 {\r\n        font-size: 21px !important;\r\n\r\n        line-height: 1.15 !important;\r\n\r\n        white-space: normal;\r\n    }\r\n\r\n\r\n    .cpa-dashboard-course {\r\n        font-size: 20px !important;\r\n    }\r\n\r\n\r\n    .cpa-dashboard-term-line {\r\n        font-size: 12px !important;\r\n    }\r\n\r\n\r\n    .cpa-section-title {\r\n        font-size: 17px !important;\r\n    }\r\n\r\n\r\n    .cpa-tech-name {\r\n        max-width: 180px;\r\n\r\n        font-size: 14px !important;\r\n    }\r\n\r\n\r\n    .cpa-analytics-table th,\r\n    .cpa-analytics-table td {\r\n        font-size: 13px !important;\r\n    }\r\n\r\n\r\n    .cpa-cell-paid,\r\n    .cpa-cell-pending {\r\n        font-size: 14px !important;\r\n    }\r\n\r\n\r\n    .cpa-term-cards {\r\n        grid-template-columns: 1fr !important;\r\n    }\r\n}\r\n\r\n\r\n/* ============================================================\r\n   18. VERY SMALL MOBILE\r\n   ============================================================ */\r\n\r\n@media (max-width: 420px) {\r\n\r\n    .cpa-masthead h1 {\r\n        font-size: 18px !important;\r\n    }\r\n\r\n\r\n    .cpa-dashboard-course {\r\n        font-size: 18px !important;\r\n    }\r\n\r\n\r\n    .cpa-tech-name {\r\n        max-width: 150px;\r\n\r\n        font-size: 13px !important;\r\n    }\r\n}\r\n\r\n/* ============================================================\r\n   TERM MULTI SELECT - FIX\r\n   ============================================================ */\r\n\r\n.cpa-term-select {\r\n    position: relative;\r\n    width: 100%;\r\n    z-index: 1000;\r\n}\r\n\r\n.cpa-term-trigger {\r\n    width: 100%;\r\n    min-height: 46px;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n\r\n    padding: 0 14px;\r\n\r\n    border: 1px solid #d7dce5;\r\n    border-radius: 8px;\r\n\r\n    background: #ffffff;\r\n    color: #1f2937;\r\n\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n\r\n    cursor: pointer;\r\n\r\n    position: relative;\r\n    z-index: 1001;\r\n}\r\n\r\n.cpa-term-trigger:hover {\r\n    border-color: #b9c2d0;\r\n}\r\n\r\n.cpa-term-trigger:focus {\r\n    outline: none;\r\n    border-color: #2563eb;\r\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.10);\r\n}\r\n\r\n.cpa-term-trigger:disabled {\r\n    cursor: not-allowed;\r\n    opacity: 0.65;\r\n}\r\n\r\n.cpa-term-trigger-text {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.cpa-chev {\r\n    flex-shrink: 0;\r\n    margin-left: 10px;\r\n    font-size: 14px;\r\n}\r\n\r\n/* ============================================================\r\n   DROPDOWN\r\n   ============================================================ */\r\n\r\n.cpa-term-dropdown {\r\n    position: absolute;\r\n\r\n    top: calc(100% + 6px);\r\n    left: 0;\r\n    right: 0;\r\n\r\n    width: 100%;\r\n    min-width: 240px;\r\n\r\n    background: #ffffff;\r\n\r\n    border: 1px solid #d9dee7;\r\n    border-radius: 9px;\r\n\r\n    box-shadow:\r\n        0 14px 35px rgba(15, 23, 42, 0.16);\r\n\r\n    z-index: 999999;\r\n\r\n    overflow: hidden;\r\n}\r\n\r\n/* ============================================================\r\n   SELECT ALL / CLEAR ALL\r\n   ============================================================ */\r\n\r\n.cpa-term-dropdown-actions {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n\r\n    padding: 9px 12px;\r\n\r\n    background: #f8fafc;\r\n\r\n    border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.cpa-term-dropdown-actions button {\r\n    border: none;\r\n    background: transparent;\r\n\r\n    color: #2563eb;\r\n\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n\r\n    padding: 5px 7px;\r\n\r\n    cursor: pointer;\r\n}\r\n\r\n.cpa-term-dropdown-actions button:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n.cpa-term-dropdown-actions button:disabled {\r\n    color: #9ca3af;\r\n    cursor: not-allowed;\r\n    text-decoration: none;\r\n}\r\n\r\n/* ============================================================\r\n   TERM OPTIONS\r\n   ============================================================ */\r\n\r\n.cpa-term-options {\r\n    width: 100%;\r\n\r\n    max-height: 240px;\r\n\r\n    overflow-y: auto;\r\n\r\n    padding: 5px 0;\r\n\r\n    background: #ffffff;\r\n}\r\n\r\n.cpa-term-option {\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    width: 100%;\r\n\r\n    gap: 10px;\r\n\r\n    padding: 10px 14px;\r\n\r\n    background: #ffffff;\r\n\r\n    color: #1f2937;\r\n\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n\r\n    cursor: pointer;\r\n\r\n    box-sizing: border-box;\r\n}\r\n\r\n.cpa-term-option:hover {\r\n    background: #f3f6fa;\r\n}\r\n\r\n.cpa-term-option input[type=\"checkbox\"] {\r\n    width: 16px;\r\n    height: 16px;\r\n\r\n    margin: 0;\r\n\r\n    flex-shrink: 0;\r\n\r\n    cursor: pointer;\r\n\r\n    accent-color: #2563eb;\r\n}\r\n\r\n.cpa-term-option span {\r\n    display: block;\r\n\r\n    color: #1f2937;\r\n\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n\r\n    opacity: 1;\r\n    visibility: visible;\r\n}\r\n\r\n/* ============================================================\r\n   EMPTY\r\n   ============================================================ */\r\n\r\n.cpa-term-empty {\r\n    padding: 15px;\r\n\r\n    text-align: center;\r\n\r\n    color: #64748b;\r\n\r\n    font-size: 12px;\r\n}\r\n\r\n/* ============================================================\r\n   FOOTER\r\n   ============================================================ */\r\n\r\n.cpa-term-dropdown-footer {\r\n    padding: 8px 12px;\r\n\r\n    border-top: 1px solid #e5e7eb;\r\n\r\n    background: #f8fafc;\r\n\r\n    color: #64748b;\r\n\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n}\r\n\r\n/* ============================================================\r\n   IMPORTANT: PREVENT DROPDOWN CLIPPING\r\n   ============================================================ */\r\n\r\n.cpa-panel {\r\n    position: relative;\r\n    z-index: 20;\r\n\r\n    overflow: visible !important;\r\n}\r\n\r\n.cpa-panel-grid {\r\n    position: relative;\r\n    z-index: 20;\r\n\r\n    overflow: visible !important;\r\n}\r\n\r\n.cpa-field {\r\n    position: relative;\r\n\r\n    overflow: visible !important;\r\n}\r\n\r\n.cpa-terms-field {\r\n    position: relative;\r\n    z-index: 1000;\r\n}\r\n\r\n.cpa-actions {\r\n    position: relative;\r\n    z-index: 1;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
